/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = T;
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** java.time.LocalDateTime implementation */
  LocalDateTime: any;
  /** java.util.Date implementation */
  Date: string;
  /** Long type */
  Long: number;
};

export type Account = {
  __typename?: 'Account';
  id: Scalars['ID'];
  name: Scalars['String'];
  bucket?: Maybe<Scalars['String']>;
  users: Array<User>;
  sessions: Array<Session>;
  accountType: AccountType;
};

export type AccountQueryInput = {
  search?: Maybe<Scalars['String']>;
  types?: Maybe<Array<Maybe<AccountType>>>;
};

export type Accounts = {
  __typename?: 'Accounts';
  accounts: Array<Account>;
};

export enum AccountType {
  Customer = 'CUSTOMER',
  Labelling = 'LABELLING'
}

export type AddLineupEntryInput = {
  id?: Maybe<Scalars['ID']>;
  type: ClassType;
  player?: Maybe<Scalars['ID']>;
  substituted?: Maybe<Scalars['ID']>;
  periodIn: PeriodType;
  periodOut?: Maybe<PeriodType>;
  inSeconds: Scalars['Int'];
  outSeconds?: Maybe<Scalars['Int']>;
  inEvent?: Maybe<Scalars['Long']>;
  outEvent?: Maybe<Scalars['Long']>;
  shirtNumber: Scalars['Int'];
  reason?: Maybe<SessionEventReason>;
};

export type AddPipelineComponentInput = {
  name: Scalars['String'];
  image: Scalars['String'];
  version: Scalars['String'];
  cpurequest: Scalars['String'];
  cpulimit?: Maybe<Scalars['String']>;
  memrequest: Scalars['String'];
  memlimit?: Maybe<Scalars['String']>;
  gpurequest?: Maybe<Scalars['Int']>;
  postprocessing: Scalars['Boolean'];
  replicas: Scalars['Int'];
  files?: Maybe<Array<Scalars['String']>>;
  inputs?: Maybe<Array<Scalars['String']>>;
  outputs?: Maybe<Array<Scalars['String']>>;
  ports?: Maybe<Array<Scalars['Int']>>;
  config_blob?: Maybe<Scalars['String']>;
  per_camera?: Maybe<Scalars['Boolean']>;
};

export type AddPipelineInput = {
  name: Scalars['String'];
  version: Scalars['String'];
  type: PipelineType;
  pipelinecomponents?: Maybe<Array<Maybe<Scalars['ID']>>>;
  topics?: Maybe<Array<Maybe<PipelineTopicInput>>>;
  componentsettings?: Maybe<Array<Maybe<ComponentSettingsInput>>>;
};

export type AddPitchInput = {
  name: Scalars['String'];
  field_length: Scalars['Int'];
  field_width: Scalars['Int'];
  pitchType?: Maybe<Scalars['String']>;
  lat: Scalars['Float'];
  lng: Scalars['Float'];
  generated?: Maybe<Scalars['Boolean']>;
  metadata?: Maybe<Scalars['String']>;
};

export type AddPlayerInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  knownAs?: Maybe<Scalars['String']>;
  keeper: Scalars['Boolean'];
  lastKnownTeam?: Maybe<Scalars['ID']>;
  lastKnownNumber?: Maybe<Scalars['Int']>;
  optaUid?: Maybe<Scalars['String']>;
};

export type AddRunInput = {
  id: Scalars['ID'];
  kafka?: Maybe<Scalars['String']>;
  startTime: Scalars['Int'];
  skipSeconds?: Maybe<Scalars['Int']>;
  stopSeconds?: Maybe<Scalars['Int']>;
  session?: Maybe<Scalars['ID']>;
  pipeline?: Maybe<Scalars['ID']>;
  inputs?: Maybe<Array<Maybe<InputInput>>>;
  pipelineSettings?: Maybe<Array<PipelineSettingInput>>;
};

export type AddSessionEventInput = {
  id?: Maybe<Scalars['ID']>;
  timestamp: Scalars['Long'];
  type: SessionEventType;
  reason?: Maybe<SessionEventReason>;
  team: Scalars['ID'];
  offscreen?: Maybe<Scalars['Boolean']>;
  in?: Maybe<SessionPlayerInput>;
  out?: Maybe<SessionPlayerInput>;
};

export type AddSessionInput = {
  pitch?: Maybe<Scalars['ID']>;
  teamHome?: Maybe<Scalars['ID']>;
  teamAway?: Maybe<Scalars['ID']>;
  teamHomeKeeperColor?: Maybe<Scalars['String']>;
  teamHomePlayersColor?: Maybe<Scalars['String']>;
  teamAwayKeeperColor?: Maybe<Scalars['String']>;
  teamAwayPlayersColor?: Maybe<Scalars['String']>;
  refereeColor?: Maybe<Scalars['String']>;
  competition?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  playedAt?: Maybe<Scalars['Long']>;
  pipeline?: Maybe<Scalars['ID']>;
  nrPlayers?: Maybe<Scalars['Int']>;
  nrKeepers?: Maybe<Scalars['Int']>;
  homeScore?: Maybe<Scalars['Int']>;
  awayScore?: Maybe<Scalars['Int']>;
  keepData?: Maybe<Scalars['Boolean']>;
  fullID?: Maybe<Scalars['Boolean']>;
  addSecondsOffset?: Maybe<Scalars['Int']>;
  matchInfoUrl?: Maybe<Scalars['String']>;
  account?: Maybe<Scalars['String']>;
  labelAccount?: Maybe<Scalars['String']>;
};

export type AddSessionLabelPositionInput = {
  id?: Maybe<Scalars['ID']>;
  videoTime: Scalars['Long'];
  classType?: Maybe<ClassType>;
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
  z?: Maybe<Scalars['Float']>;
};

export type AddSessionPeriodInput = {
  id?: Maybe<Scalars['ID']>;
  type: PeriodType;
  startTime: Scalars['Long'];
  endTime: Scalars['Long'];
  label?: Maybe<Scalars['String']>;
};

export type AddSessionVideoInput = {
  id?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  sortOrder: Scalars['Int'];
  videoInfo: VideoInfoInput;
  calibration?: Maybe<Scalars['String']>;
  clickPoints?: Maybe<Scalars['String']>;
};

export type AddTeamInput = {
  name: Scalars['String'];
  keeperColor?: Maybe<Scalars['String']>;
  playerColor?: Maybe<Scalars['String']>;
};

export type AddTrackLabelTaskInput = {
  id?: Maybe<Scalars['ID']>;
  start_frame: Scalars['Int'];
  end_frame: Scalars['Int'];
  start_x: Scalars['Float'];
  start_y: Scalars['Float'];
  start_z: Scalars['Float'];
  class_type: ClassType;
  lineupentry?: Maybe<Scalars['ID']>;
  owner?: Maybe<Scalars['ID']>;
};

export type AuditLog = {
  __typename?: 'AuditLog';
  type: AuditLogType;
  timestamp: Scalars['Date'];
  params?: Maybe<Scalars['String']>;
  sessionid?: Maybe<Scalars['Long']>;
  user?: Maybe<User>;
};

export type AuditLogs = {
  __typename?: 'AuditLogs';
  logs?: Maybe<Array<AuditLog>>;
  count: Scalars['Long'];
};

export enum AuditLogType {
  StartSession = 'START_SESSION',
  UploadVideo = 'UPLOAD_VIDEO',
  AddSession = 'ADD_SESSION',
  UpdateSession = 'UPDATE_SESSION',
  DeleteSession = 'DELETE_SESSION',
  ExportEpts = 'EXPORT_EPTS',
  UpdateCalibration = 'UPDATE_CALIBRATION',
  AddVideo = 'ADD_VIDEO',
  UpdateVideo = 'UPDATE_VIDEO',
  DeleteVideo = 'DELETE_VIDEO',
  AddLabelPosition = 'ADD_LABEL_POSITION',
  DeleteLabelPosition = 'DELETE_LABEL_POSITION',
  AddPeriod = 'ADD_PERIOD',
  UpdatePeriod = 'UPDATE_PERIOD',
  DeletePeriod = 'DELETE_PERIOD',
  AddEvent = 'ADD_EVENT',
  UpdateEvent = 'UPDATE_EVENT',
  DeleteEvent = 'DELETE_EVENT',
  AddLabelTasks = 'ADD_LABEL_TASKS',
  UpdateLabelTask = 'UPDATE_LABEL_TASK',
  DeleteLabelTask = 'DELETE_LABEL_TASK',
  ClearLabelTasks = 'CLEAR_LABEL_TASKS',
  UpdateVideoOrder = 'UPDATE_VIDEO_ORDER',
  UpdateCalibrationImage = 'UPDATE_CALIBRATION_IMAGE',
  OptaF7Import = 'OPTA_F7_IMPORT',
  UpdateLineup = 'UPDATE_LINEUP',
  AddRun = 'ADD_RUN',
  UpdateRun = 'UPDATE_RUN',
  StartRun = 'START_RUN',
  StopRun = 'STOP_RUN',
  DeleteRunData = 'DELETE_RUN_DATA',
  DeleteRun = 'DELETE_RUN',
  ResetRun = 'RESET_RUN',
  UpdateAccount = 'UPDATE_ACCOUNT',
  AddAccount = 'ADD_ACCOUNT',
  DeleteAccount = 'DELETE_ACCOUNT',
  StartStream = 'START_STREAM',
  DeletePipeline = 'DELETE_PIPELINE',
  DeletePipelineComponent = 'DELETE_PIPELINE_COMPONENT',
  UpdatePipeline = 'UPDATE_PIPELINE',
  AddPipeline = 'ADD_PIPELINE',
  UpdatePipelineComponent = 'UPDATE_PIPELINE_COMPONENT',
  AddPipelineComponent = 'ADD_PIPELINE_COMPONENT',
  UpdateSettings = 'UPDATE_SETTINGS',
  DeletePitch = 'DELETE_PITCH',
  AddPitch = 'ADD_PITCH',
  UpdatePitch = 'UPDATE_PITCH',
  CreateUser = 'CREATE_USER',
  LoginUser = 'LOGIN_USER',
  ResendInvite = 'RESEND_INVITE',
  ChangePassword = 'CHANGE_PASSWORD',
  ConfirmRegistration = 'CONFIRM_REGISTRATION',
  ResetPassword = 'RESET_PASSWORD',
  CreateRole = 'CREATE_ROLE',
  UpdateRole = 'UPDATE_ROLE',
  DeleteUser = 'DELETE_USER',
  ForgotPassword = 'FORGOT_PASSWORD',
  UpdateUser = 'UPDATE_USER',
  StartTranscode = 'START_TRANSCODE',
  UpdateTranscodeStatus = 'UPDATE_TRANSCODE_STATUS',
  NamespaceCreated = 'NAMESPACE_CREATED',
  TopicsCreated = 'TOPICS_CREATED',
  RunStarted = 'RUN_STARTED',
  RunStopped = 'RUN_STOPPED',
  DeploymentsStarted = 'DEPLOYMENTS_STARTED',
  DeploymentsStopped = 'DEPLOYMENTS_STOPPED',
  NamespaceDeleted = 'NAMESPACE_DELETED',
  PostProcessingFinished = 'POST_PROCESSING_FINISHED',
  RunError = 'RUN_ERROR',
  RunDeleted = 'RUN_DELETED',
  RunReset = 'RUN_RESET',
  StartLabel = 'START_LABEL',
  EndLabel = 'END_LABEL',
  ExportStart = 'EXPORT_START',
  ExportUpdate = 'EXPORT_UPDATE',
  ZookeeperCreated = 'ZOOKEEPER_CREATED',
  KafkaCreated = 'KAFKA_CREATED'
}

export type AuditQueryInput = {
  pagination?: Maybe<Pagination>;
  sorting?: Maybe<Array<Maybe<Sorting>>>;
  search?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['Long']>;
  until?: Maybe<Scalars['Long']>;
  user?: Maybe<Scalars['ID']>;
  session?: Maybe<Scalars['ID']>;
  types?: Maybe<Array<AuditLogType>>;
};

export type ChangePasswordInput = {
  id?: Maybe<Scalars['ID']>;
  password: Scalars['String'];
};

export type ChangePasswordOutput = {
  __typename?: 'ChangePasswordOutput';
  user?: Maybe<User>;
};

export enum ClassType {
  HomePlayer = 'HOME_PLAYER',
  HomeKeeper = 'HOME_KEEPER',
  AwayPlayer = 'AWAY_PLAYER',
  AwayKeeper = 'AWAY_KEEPER',
  Referee = 'REFEREE',
  Ball = 'BALL'
}

export type ComponentSettingsInput = {
  component: Scalars['String'];
  inputmap?: Maybe<Array<TopicMapping>>;
  outputmap?: Maybe<Array<TopicMapping>>;
};

export type ComponentState = {
  __typename?: 'ComponentState';
  state: DeploymentState;
  replicas: Scalars['Int'];
  failed: Scalars['Int'];
  succeeded: Scalars['Int'];
  active: Scalars['Int'];
  running: Scalars['Int'];
};

export type ComponentStatus = {
  __typename?: 'ComponentStatus';
  component: PipelineComponent;
  settings?: Maybe<PipelineComponentSettings>;
  state: ComponentState;
  instances?: Maybe<Array<InstanceState>>;
};

export type ConfirmRegistrationInput = {
  password: Scalars['String'];
};

export type ConfirmRegistrationOutput = {
  __typename?: 'ConfirmRegistrationOutput';
  user?: Maybe<User>;
};

export type CreateRoleInput = {
  name: Scalars['String'];
  privileges: Array<Privilege>;
};

export type CreateRoleOutput = {
  __typename?: 'CreateRoleOutput';
  role?: Maybe<Role>;
};

export type CreateUserInput = {
  email: Scalars['String'];
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  account: Scalars['String'];
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type CreateUserOutput = {
  __typename?: 'CreateUserOutput';
  user?: Maybe<User>;
  error?: Maybe<Scalars['String']>;
};


export type DeletePipelineOutput = {
  __typename?: 'DeletePipelineOutput';
  result?: Maybe<Scalars['String']>;
};

export type DeletePitchOutput = {
  __typename?: 'DeletePitchOutput';
  result?: Maybe<Scalars['String']>;
};

export type DeleteUserInput = {
  id: Scalars['ID'];
};

export type DeleteUserOutput = {
  __typename?: 'DeleteUserOutput';
  result?: Maybe<Scalars['String']>;
};

export enum DeploymentState {
  NotDeployed = 'NOT_DEPLOYED',
  Error = 'ERROR',
  Running = 'RUNNING',
  PartiallyRunning = 'PARTIALLY_RUNNING'
}

export type ExportStatus = {
  __typename?: 'ExportStatus';
  file_exporter_status?: Maybe<Scalars['String']>;
  progress?: Maybe<Scalars['Float']>;
  job_id?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  finish_state?: Maybe<FinishState>;
};

export enum FinishState {
  Succeeded = 'succeeded',
  Failed = 'failed',
  Stopped = 'stopped',
  ExternallyDeleted = 'externally_deleted',
  StartTimeout = 'start_timeout'
}

export type ForgotPasswordInput = {
  email: Scalars['String'];
};

export type ForgotPasswordOutput = {
  __typename?: 'ForgotPasswordOutput';
  result?: Maybe<Scalars['String']>;
};

export type Input = {
  __typename?: 'Input';
  input: Scalars['String'];
  output: Scalars['String'];
};

export type InputInput = {
  input: Scalars['String'];
  output: Scalars['String'];
};

export type InstanceState = {
  __typename?: 'InstanceState';
  pod: Scalars['String'];
  status: V1PodStatus;
  log: Scalars['String'];
};

export type LineupEntry = {
  __typename?: 'LineupEntry';
  id: Scalars['ID'];
  session: Session;
  type: ClassType;
  player?: Maybe<Player>;
  substituted?: Maybe<Player>;
  periodIn: PeriodType;
  periodOut?: Maybe<PeriodType>;
  inSeconds: Scalars['Int'];
  outSeconds?: Maybe<Scalars['Int']>;
  shirtNumber: Scalars['Int'];
  reason?: Maybe<SessionEventReason>;
  inEvent?: Maybe<SessionEvent>;
  outEvent?: Maybe<SessionEvent>;
  dataFrames?: Maybe<Array<LineupEntryFrame>>;
  firstFrame: Scalars['Int'];
  lastFrame: Scalars['Int'];
};

export type LineupEntryFrame = {
  __typename?: 'LineupEntryFrame';
  first: Scalars['Int'];
  last: Scalars['Int'];
};


export type LoginInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type LoginOutput = {
  __typename?: 'LoginOutput';
  user?: Maybe<User>;
};

export type LoginTokenInput = {
  token: Scalars['String'];
};

export type LoginTokenOutput = {
  __typename?: 'LoginTokenOutput';
  user?: Maybe<User>;
};


export type Mapping = {
  __typename?: 'Mapping';
  in: Scalars['String'];
  topic: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addTeam?: Maybe<Team>;
  updateSettings?: Maybe<Settings>;
  addPlayer?: Maybe<Player>;
  addPitch?: Maybe<Pitch>;
  updatePitch?: Maybe<Pitch>;
  deletePitch?: Maybe<DeletePitchOutput>;
  addRun?: Maybe<Run>;
  updateRun?: Maybe<Run>;
  startRun?: Maybe<Run>;
  stopRun?: Maybe<Run>;
  deleteData?: Maybe<RunStatus>;
  deleteRun?: Maybe<Scalars['Boolean']>;
  resetRun?: Maybe<Scalars['Boolean']>;
  addPipeline?: Maybe<Pipeline>;
  updatePipeline?: Maybe<Pipeline>;
  addPipelineComponent?: Maybe<PipelineComponent>;
  updatePipelineComponent?: Maybe<PipelineComponent>;
  deletePipeline?: Maybe<DeletePipelineOutput>;
  deletePipelineComponent?: Maybe<Scalars['Boolean']>;
  addAccount?: Maybe<Account>;
  deleteAccount?: Maybe<Scalars['Boolean']>;
  updateAccount?: Maybe<Account>;
  addSession?: Maybe<Session>;
  updateSession?: Maybe<Session>;
  sessionAddVideo?: Maybe<Session>;
  sessionUpdateVideo?: Maybe<Session>;
  sessionDeleteVideo?: Maybe<Session>;
  sessionAddLabelPosition?: Maybe<Session>;
  sessionDeleteLabelPositions?: Maybe<Session>;
  sessionAddPeriod?: Maybe<Session>;
  sessionUpdatePeriod?: Maybe<Session>;
  sessionDeletePeriod?: Maybe<Session>;
  sessionAddEvent?: Maybe<Session>;
  sessionUpdateEvent?: Maybe<Session>;
  sessionDeleteEvent?: Maybe<Session>;
  sessionUpdateTrackLabelTask?: Maybe<Session>;
  sessionAddTrackLabelTasks?: Maybe<Session>;
  sessionDeleteTrackLabelTask?: Maybe<Session>;
  sessionClearTrackLabelTasks?: Maybe<Session>;
  startSession?: Maybe<Session>;
  deleteSession?: Maybe<Scalars['Boolean']>;
  updateCalibration?: Maybe<SessionVideo>;
  updateCalibrationImage?: Maybe<Scalars['Boolean']>;
  updateVideoOrder?: Maybe<Session>;
  importOptaF7?: Maybe<Session>;
  sessionAddUpdateLineup?: Maybe<Session>;
  exportEpts?: Maybe<Session>;
  login?: Maybe<LoginOutput>;
  loginToken?: Maybe<LoginTokenOutput>;
  createUser?: Maybe<CreateUserOutput>;
  confirmRegistration?: Maybe<ConfirmRegistrationOutput>;
  changePassword?: Maybe<ChangePasswordOutput>;
  resetPassword?: Maybe<ResetPasswordOutput>;
  forgotPassword?: Maybe<ForgotPasswordOutput>;
  updateUser?: Maybe<UpdateUserOutput>;
  createRole?: Maybe<CreateRoleOutput>;
  updateRole?: Maybe<UpdateRoleOutput>;
  deleteUser?: Maybe<DeleteUserOutput>;
  resendInvite?: Maybe<Scalars['Boolean']>;
};


export type MutationAddTeamArgs = {
  input?: Maybe<AddTeamInput>;
};


export type MutationUpdateSettingsArgs = {
  input?: Maybe<UpdateSettingsInput>;
};


export type MutationAddPlayerArgs = {
  input?: Maybe<AddPlayerInput>;
};


export type MutationAddPitchArgs = {
  input?: Maybe<AddPitchInput>;
};


export type MutationUpdatePitchArgs = {
  id: Scalars['ID'];
  input?: Maybe<AddPitchInput>;
};


export type MutationDeletePitchArgs = {
  id: Scalars['ID'];
};


export type MutationAddRunArgs = {
  input?: Maybe<AddRunInput>;
};


export type MutationUpdateRunArgs = {
  id?: Maybe<Scalars['ID']>;
  input?: Maybe<AddRunInput>;
};


export type MutationStartRunArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type MutationStopRunArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type MutationDeleteDataArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type MutationDeleteRunArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type MutationResetRunArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type MutationAddPipelineArgs = {
  input?: Maybe<AddPipelineInput>;
};


export type MutationUpdatePipelineArgs = {
  id: Scalars['ID'];
  update?: Maybe<AddPipelineInput>;
};


export type MutationAddPipelineComponentArgs = {
  input?: Maybe<AddPipelineComponentInput>;
};


export type MutationUpdatePipelineComponentArgs = {
  id: Scalars['ID'];
  update?: Maybe<AddPipelineComponentInput>;
};


export type MutationDeletePipelineArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePipelineComponentArgs = {
  id: Scalars['ID'];
};


export type MutationAddAccountArgs = {
  id: Scalars['ID'];
  name: Scalars['String'];
  accountType: AccountType;
};


export type MutationDeleteAccountArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateAccountArgs = {
  id: Scalars['ID'];
  name: Scalars['String'];
};


export type MutationAddSessionArgs = {
  input?: Maybe<AddSessionInput>;
};


export type MutationUpdateSessionArgs = {
  id: Scalars['ID'];
  input?: Maybe<AddSessionInput>;
};


export type MutationSessionAddVideoArgs = {
  id?: Maybe<Scalars['ID']>;
  input: AddSessionVideoInput;
};


export type MutationSessionUpdateVideoArgs = {
  id?: Maybe<Scalars['ID']>;
  input: AddSessionVideoInput;
};


export type MutationSessionDeleteVideoArgs = {
  id: Scalars['ID'];
  videoId: Scalars['ID'];
};


export type MutationSessionAddLabelPositionArgs = {
  id?: Maybe<Scalars['ID']>;
  input: AddSessionLabelPositionInput;
};


export type MutationSessionDeleteLabelPositionsArgs = {
  id: Scalars['ID'];
  labelPositionIds?: Maybe<Array<Scalars['ID']>>;
};


export type MutationSessionAddPeriodArgs = {
  id?: Maybe<Scalars['ID']>;
  input: AddSessionPeriodInput;
};


export type MutationSessionUpdatePeriodArgs = {
  id?: Maybe<Scalars['ID']>;
  input: AddSessionPeriodInput;
};


export type MutationSessionDeletePeriodArgs = {
  id: Scalars['ID'];
  periodId: Scalars['ID'];
};


export type MutationSessionAddEventArgs = {
  id?: Maybe<Scalars['ID']>;
  input: AddSessionEventInput;
};


export type MutationSessionUpdateEventArgs = {
  id?: Maybe<Scalars['ID']>;
  input: AddSessionEventInput;
};


export type MutationSessionDeleteEventArgs = {
  id: Scalars['ID'];
  eventId: Scalars['ID'];
};


export type MutationSessionUpdateTrackLabelTaskArgs = {
  id: Scalars['ID'];
  input: AddTrackLabelTaskInput;
};


export type MutationSessionAddTrackLabelTasksArgs = {
  id: Scalars['ID'];
  input?: Maybe<Array<AddTrackLabelTaskInput>>;
};


export type MutationSessionDeleteTrackLabelTaskArgs = {
  id: Scalars['ID'];
  taskId: Scalars['ID'];
};


export type MutationSessionClearTrackLabelTasksArgs = {
  id: Scalars['ID'];
};


export type MutationStartSessionArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteSessionArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateCalibrationArgs = {
  id: Scalars['ID'];
  calibration: Scalars['String'];
  clickPoints: Scalars['String'];
};


export type MutationUpdateCalibrationImageArgs = {
  id: Scalars['ID'];
  calibrationImage: Scalars['String'];
};


export type MutationUpdateVideoOrderArgs = {
  id: Scalars['ID'];
  order: Array<VideoOrderInput>;
};


export type MutationImportOptaF7Args = {
  id?: Maybe<Scalars['ID']>;
  xml: Scalars['String'];
};


export type MutationSessionAddUpdateLineupArgs = {
  id: Scalars['ID'];
  input?: Maybe<Array<AddLineupEntryInput>>;
};


export type MutationExportEptsArgs = {
  id: Scalars['ID'];
  autonomous: Scalars['Boolean'];
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationLoginTokenArgs = {
  input: LoginTokenInput;
};


export type MutationCreateUserArgs = {
  input?: Maybe<CreateUserInput>;
};


export type MutationConfirmRegistrationArgs = {
  input?: Maybe<ConfirmRegistrationInput>;
};


export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationForgotPasswordArgs = {
  input: ForgotPasswordInput;
};


export type MutationUpdateUserArgs = {
  input?: Maybe<UpdateUserInput>;
};


export type MutationCreateRoleArgs = {
  input?: Maybe<CreateRoleInput>;
};


export type MutationUpdateRoleArgs = {
  input?: Maybe<UpdateRoleInput>;
};


export type MutationDeleteUserArgs = {
  input?: Maybe<DeleteUserInput>;
};


export type MutationResendInviteArgs = {
  id: Scalars['ID'];
};

export type Pagination = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};

export enum PeriodType {
  FirstHalf = 'FIRST_HALF',
  SecondHalf = 'SECOND_HALF',
  ExtraTimeFirstHalf = 'EXTRA_TIME_FIRST_HALF',
  ExtraTimeSecondHalf = 'EXTRA_TIME_SECOND_HALF',
  Penalties = 'PENALTIES',
  Other = 'OTHER'
}

export type Pipeline = {
  __typename?: 'Pipeline';
  id: Scalars['ID'];
  name: Scalars['String'];
  version: Scalars['String'];
  runs?: Maybe<Array<Run>>;
  pipelinecomponents?: Maybe<Array<PipelineComponent>>;
  pipelineComponentSettings?: Maybe<Array<PipelineComponentSettings>>;
  topics?: Maybe<Array<PipelineTopic>>;
  created: Scalars['Date'];
  createdBy: User;
  type: PipelineType;
};

export type PipelineComponent = {
  __typename?: 'PipelineComponent';
  id?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  image: Scalars['String'];
  version: Scalars['String'];
  cpurequest: Scalars['String'];
  cpulimit: Scalars['String'];
  memrequest: Scalars['String'];
  memlimit: Scalars['String'];
  gpurequest: Scalars['Int'];
  replicas: Scalars['Int'];
  files?: Maybe<Array<Scalars['String']>>;
  config_blob?: Maybe<Scalars['String']>;
  postprocessing: Scalars['Boolean'];
  pipelines?: Maybe<Array<Maybe<Pipeline>>>;
  inputs?: Maybe<Array<Scalars['String']>>;
  outputs?: Maybe<Array<Scalars['String']>>;
  ports?: Maybe<Array<Scalars['Int']>>;
  per_camera?: Maybe<Scalars['Boolean']>;
};

export type PipelineComponentSettings = {
  __typename?: 'PipelineComponentSettings';
  id: Scalars['ID'];
  pipeline: Pipeline;
  pipelineComponent: PipelineComponent;
  inputmap?: Maybe<Array<Mapping>>;
  outputmap?: Maybe<Array<Mapping>>;
};

export type PipelineQueryInput = {
  pagination?: Maybe<Pagination>;
  sorting?: Maybe<Array<Maybe<Sorting>>>;
  versions?: Maybe<Array<Maybe<Scalars['String']>>>;
  search?: Maybe<Scalars['String']>;
  types?: Maybe<Array<Maybe<PipelineType>>>;
  components?: Maybe<Array<Maybe<Scalars['ID']>>>;
  creationStart?: Maybe<Scalars['Long']>;
  creationEnd?: Maybe<Scalars['Long']>;
  lastRunStart?: Maybe<Scalars['Long']>;
  lastRunEnd?: Maybe<Scalars['Long']>;
};

export type Pipelines = {
  __typename?: 'Pipelines';
  pipelines?: Maybe<Array<Pipeline>>;
  count: Scalars['Long'];
};

export type PipelineSetting = {
  __typename?: 'PipelineSetting';
  plc: PipelineComponent;
  setting: Scalars['String'];
  value: Scalars['String'];
};

export type PipelineSettingInput = {
  plc: Scalars['ID'];
  setting: Scalars['String'];
  value: Scalars['String'];
};

export type PipelineTopic = {
  __typename?: 'PipelineTopic';
  pipeline: Pipeline;
  topic: Scalars['String'];
  partitions: Scalars['Int'];
  replication_factor: Scalars['Int'];
  compress: Scalars['Boolean'];
  per_camera?: Maybe<Scalars['Boolean']>;
};

export type PipelineTopicInput = {
  topic: Scalars['String'];
  partitions: Scalars['Int'];
  replication_factor: Scalars['Int'];
  compress: Scalars['Boolean'];
  per_camera?: Maybe<Scalars['Boolean']>;
};

export enum PipelineType {
  Dev = 'DEV',
  Acc = 'ACC',
  Prod = 'PROD'
}

export type Pitch = {
  __typename?: 'Pitch';
  id: Scalars['ID'];
  name: Scalars['String'];
  sessions?: Maybe<Array<Session>>;
  pitchType?: Maybe<Scalars['String']>;
  field_length: Scalars['Int'];
  field_width: Scalars['Int'];
  lat: Scalars['Float'];
  lng: Scalars['Float'];
  timeZone: Scalars['String'];
  generated?: Maybe<Scalars['Boolean']>;
};

export type Player = {
  __typename?: 'Player';
  id: Scalars['ID'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  knownAs?: Maybe<Scalars['String']>;
  keeper?: Maybe<Scalars['Boolean']>;
  lastKnownTeam?: Maybe<Team>;
  lastKnownNumber?: Maybe<Scalars['Int']>;
  optaUid?: Maybe<Scalars['String']>;
};

export enum Privilege {
  ReadUsers = 'READ_USERS',
  WriteUsers = 'WRITE_USERS',
  WritePitches = 'WRITE_PITCHES',
  Admin = 'ADMIN',
  ReadLabelTasks = 'READ_LABEL_TASKS',
  WriteLabelTasks = 'WRITE_LABEL_TASKS',
  ReadPipeline = 'READ_PIPELINE',
  WritePipeline = 'WRITE_PIPELINE',
  ReadPipelineComponent = 'READ_PIPELINE_COMPONENT',
  WritePipelineComponent = 'WRITE_PIPELINE_COMPONENT',
  ReadPitch = 'READ_PITCH',
  WritePitch = 'WRITE_PITCH',
  ReadSession = 'READ_SESSION',
  WriteSession = 'WRITE_SESSION',
  ReadRun = 'READ_RUN',
  WriteRun = 'WRITE_RUN',
  DownloadData = 'DOWNLOAD_DATA',
  ReadAuditLogs = 'READ_AUDIT_LOGS',
  AssignLabelTasks = 'ASSIGN_LABEL_TASKS',
  ExportData = 'EXPORT_DATA'
}

export type Query = {
  __typename?: 'Query';
  allsessions?: Maybe<Array<Session>>;
  sessions?: Maybe<Sessions>;
  session?: Maybe<Session>;
  sessionResult?: Maybe<Array<Scalars['String']>>;
  videoInfo?: Maybe<VideoInfo>;
  sessionVideo?: Maybe<SessionVideo>;
  snapshot: Scalars['String'];
  matchingVideo?: Maybe<SessionVideo>;
  labelTask?: Maybe<TrackLabelTask>;
  settings?: Maybe<Settings>;
  pods?: Maybe<Array<Scalars['String']>>;
  pitch?: Maybe<Pitch>;
  pitchByName?: Maybe<Pitch>;
  pitches?: Maybe<Array<Pitch>>;
  teams?: Maybe<Array<Team>>;
  runs?: Maybe<Runs>;
  run?: Maybe<Run>;
  runStatus?: Maybe<RunStatus>;
  componentStatus: ComponentStatus;
  players?: Maybe<Array<Player>>;
  me?: Maybe<User>;
  user?: Maybe<User>;
  allUsers?: Maybe<Users>;
  users?: Maybe<Array<User>>;
  roles?: Maybe<Roles>;
  privileges?: Maybe<Array<Privilege>>;
  pipelines?: Maybe<Pipelines>;
  pipeline?: Maybe<Pipeline>;
  allpipelines?: Maybe<Array<Pipeline>>;
  pipelinecomponents?: Maybe<Array<PipelineComponent>>;
  pipelinecomponent?: Maybe<PipelineComponent>;
  auditlogs?: Maybe<AuditLogs>;
  accounts: Accounts;
  account?: Maybe<Account>;
};


export type QuerySessionsArgs = {
  input?: Maybe<SessionQueryInput>;
};


export type QuerySessionArgs = {
  id: Scalars['ID'];
};


export type QuerySessionResultArgs = {
  id: Scalars['ID'];
};


export type QueryVideoInfoArgs = {
  url: Scalars['String'];
};


export type QuerySessionVideoArgs = {
  id: Scalars['ID'];
};


export type QuerySnapshotArgs = {
  id: Scalars['ID'];
};


export type QueryMatchingVideoArgs = {
  id: Scalars['ID'];
};


export type QueryLabelTaskArgs = {
  id: Scalars['ID'];
};


export type QueryPodsArgs = {
  namespace: Scalars['String'];
  deployment: Scalars['String'];
};


export type QueryPitchArgs = {
  id: Scalars['ID'];
};


export type QueryPitchByNameArgs = {
  name: Scalars['String'];
  generated?: Maybe<Scalars['Boolean']>;
  metadata?: Maybe<Scalars['String']>;
};


export type QueryRunsArgs = {
  input?: Maybe<RunQueryInput>;
};


export type QueryRunArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryRunStatusArgs = {
  id: Scalars['ID'];
};


export type QueryComponentStatusArgs = {
  run: Scalars['String'];
  component: Scalars['String'];
};


export type QueryPlayersArgs = {
  team?: Maybe<Scalars['ID']>;
  search?: Maybe<Scalars['String']>;
};


export type QueryUserArgs = {
  id: Scalars['ID'];
};


export type QueryAllUsersArgs = {
  pagination?: Maybe<Pagination>;
  sorting?: Maybe<Array<Maybe<Sorting>>>;
  search?: Maybe<Scalars['String']>;
  account?: Maybe<Scalars['String']>;
};


export type QueryPipelinesArgs = {
  input?: Maybe<PipelineQueryInput>;
};


export type QueryPipelineArgs = {
  id: Scalars['ID'];
};


export type QueryPipelinecomponentArgs = {
  id: Scalars['ID'];
};


export type QueryAuditlogsArgs = {
  input?: Maybe<AuditQueryInput>;
};


export type QueryAccountsArgs = {
  input?: Maybe<AccountQueryInput>;
};


export type QueryAccountArgs = {
  id: Scalars['ID'];
};

export type ResetPasswordInput = {
  password: Scalars['String'];
};

export type ResetPasswordOutput = {
  __typename?: 'ResetPasswordOutput';
  user?: Maybe<User>;
};

export type Role = {
  __typename?: 'Role';
  name: Scalars['String'];
  privileges: Array<Privilege>;
};

export type Roles = {
  __typename?: 'Roles';
  roles?: Maybe<Array<Maybe<Role>>>;
  count: Scalars['Int'];
};

export type Run = {
  __typename?: 'Run';
  id?: Maybe<Scalars['ID']>;
  pipeline: Pipeline;
  status: RunStatus;
  session?: Maybe<Session>;
  startTime: Scalars['Date'];
  stopTime?: Maybe<Scalars['Date']>;
  doneTime?: Maybe<Scalars['Date']>;
  bootTime?: Maybe<Scalars['Date']>;
  haltTime?: Maybe<Scalars['Date']>;
  deleteTime?: Maybe<Scalars['Date']>;
  inputs?: Maybe<Array<Input>>;
  created?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<User>;
  errorMessage?: Maybe<Scalars['String']>;
  kafka?: Maybe<Scalars['String']>;
  skipSeconds?: Maybe<Scalars['Int']>;
  stopSeconds?: Maybe<Scalars['Int']>;
  pipelineSettings?: Maybe<Array<PipelineSetting>>;
  exportStatus?: Maybe<ExportStatus>;
  saveRunStatus?: Maybe<SaveRunStatus>;
  runExportStatus?: Maybe<RunExportStatus>;
};

export enum RunExportStatus {
  NotStarted = 'NOT_STARTED',
  SavingRun = 'SAVING_RUN',
  Exporting = 'EXPORTING',
  Exported = 'EXPORTED',
  Failed = 'FAILED'
}

export type RunQueryInput = {
  pagination?: Maybe<Pagination>;
  sorting?: Maybe<Array<Maybe<Sorting>>>;
  search?: Maybe<Scalars['String']>;
  creationStart?: Maybe<Scalars['Long']>;
  creationEnd?: Maybe<Scalars['Long']>;
  runStart?: Maybe<Scalars['Long']>;
  runEnd?: Maybe<Scalars['Long']>;
  statuses?: Maybe<Array<RunState>>;
  completedOnly?: Maybe<Scalars['Boolean']>;
  pipelines?: Maybe<Array<Maybe<Scalars['ID']>>>;
  pitches?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type Runs = {
  __typename?: 'Runs';
  runs?: Maybe<Array<Run>>;
  count: Scalars['Long'];
};

export enum RunState {
  Created = 'CREATED',
  CreateNamespace = 'CREATE_NAMESPACE',
  CreateTopics = 'CREATE_TOPICS',
  StartDeployments = 'START_DEPLOYMENTS',
  Running = 'RUNNING',
  StopDeployments = 'STOP_DEPLOYMENTS',
  PostProcess = 'POST_PROCESS',
  StopDeploymentsError = 'STOP_DEPLOYMENTS_ERROR',
  DeleteNamespace = 'DELETE_NAMESPACE',
  Stopped = 'STOPPED',
  Deleted = 'DELETED',
  CreateKafkaZookeeper = 'CREATE_KAFKA_ZOOKEEPER'
}

export type RunStatus = {
  __typename?: 'RunStatus';
  runid: Scalars['ID'];
  state: RunState;
  components?: Maybe<Array<ComponentStatus>>;
};

export type SaveRunStatus = {
  __typename?: 'SaveRunStatus';
  percent_completed?: Maybe<Scalars['Int']>;
};

export type Session = {
  __typename?: 'Session';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  pitch?: Maybe<Pitch>;
  account: Account;
  labelAccount?: Maybe<Account>;
  createdBy: User;
  teamHome?: Maybe<Team>;
  teamAway?: Maybe<Team>;
  teamHomePlayersColor?: Maybe<Scalars['String']>;
  teamAwayPlayersColor?: Maybe<Scalars['String']>;
  teamHomeKeeperColor?: Maybe<Scalars['String']>;
  teamAwayKeeperColor?: Maybe<Scalars['String']>;
  refereeColor?: Maybe<Scalars['String']>;
  competition?: Maybe<Scalars['String']>;
  pipeline?: Maybe<Pipeline>;
  videos?: Maybe<Array<SessionVideo>>;
  createdAt?: Maybe<Scalars['Date']>;
  startedAt?: Maybe<Scalars['Date']>;
  finishedAt?: Maybe<Scalars['Date']>;
  playedAt?: Maybe<Scalars['Date']>;
  nrPlayers?: Maybe<Scalars['Int']>;
  nrKeepers?: Maybe<Scalars['Int']>;
  homeScore?: Maybe<Scalars['Int']>;
  awayScore?: Maybe<Scalars['Int']>;
  keepData?: Maybe<Scalars['Boolean']>;
  fullID?: Maybe<Scalars['Boolean']>;
  labelPositions?: Maybe<Array<SessionLabelPosition>>;
  periods?: Maybe<Array<SessionPeriod>>;
  location: Scalars['String'];
  events?: Maybe<Array<SessionEvent>>;
  labelTasks?: Maybe<Array<TrackLabelTask>>;
  lineup?: Maybe<Array<LineupEntry>>;
  label?: Maybe<Scalars['String']>;
  lastRun?: Maybe<Run>;
  addSecondsOffset?: Maybe<Scalars['Int']>;
  matchInfoUrl?: Maybe<Scalars['String']>;
  approved?: Maybe<Scalars['Boolean']>;
};

export type SessionEvent = {
  __typename?: 'SessionEvent';
  id: Scalars['ID'];
  timestamp: Scalars['Long'];
  type: SessionEventType;
  reason?: Maybe<SessionEventReason>;
  team?: Maybe<Team>;
  in?: Maybe<SessionPlayer>;
  out?: Maybe<SessionPlayer>;
  offscreen?: Maybe<Scalars['Boolean']>;
};

export enum SessionEventReason {
  Substitution = 'substitution',
  RedCard = 'red_card',
  Injury = 'injury'
}

export enum SessionEventType {
  LineupChange = 'lineup_change'
}

export type SessionLabelPosition = {
  __typename?: 'SessionLabelPosition';
  id: Scalars['ID'];
  videoTime: Scalars['Long'];
  classType?: Maybe<ClassType>;
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
  z?: Maybe<Scalars['Float']>;
};

export type SessionPeriod = {
  __typename?: 'SessionPeriod';
  id: Scalars['ID'];
  type: PeriodType;
  startTime: Scalars['Long'];
  endTime: Scalars['Long'];
  label?: Maybe<Scalars['String']>;
  teamLeft?: Maybe<Team>;
};

export type SessionPlayer = {
  __typename?: 'SessionPlayer';
  id: Scalars['ID'];
  type: SessionPlayerType;
  number: Scalars['Int'];
};

export type SessionPlayerInput = {
  type: SessionPlayerType;
  number: Scalars['Int'];
};

export enum SessionPlayerType {
  Keeper = 'keeper',
  Player = 'player'
}

export type SessionQueryInput = {
  pagination?: Maybe<Pagination>;
  sorting?: Maybe<Array<Maybe<Sorting>>>;
  search?: Maybe<Scalars['String']>;
  creationStart?: Maybe<Scalars['Long']>;
  creationEnd?: Maybe<Scalars['Long']>;
  pitches?: Maybe<Array<Maybe<Scalars['ID']>>>;
  approved?: Maybe<Scalars['Boolean']>;
};

export type Sessions = {
  __typename?: 'Sessions';
  sessions?: Maybe<Array<Session>>;
  count: Scalars['Long'];
};

export type SessionVideo = {
  __typename?: 'SessionVideo';
  id: Scalars['ID'];
  url?: Maybe<Scalars['String']>;
  videoInfo?: Maybe<VideoInfo>;
  calibration?: Maybe<Scalars['String']>;
  clickPoints?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
  syncOffset?: Maybe<Scalars['Int']>;
  ip?: Maybe<Scalars['String']>;
  transcodeStatus?: Maybe<VideoTranscodeStatus>;
};

export type Settings = {
  __typename?: 'Settings';
  id: Scalars['ID'];
  defaultPipeline?: Maybe<Pipeline>;
  sessionsBucket?: Maybe<Scalars['String']>;
  backendVersion?: Maybe<Scalars['String']>;
  frontendVersion?: Maybe<Scalars['String']>;
  apiVersion?: Maybe<Scalars['Int']>;
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Sorting = {
  sortBy: Scalars['String'];
  sortDirection: SortDirection;
};

export type Team = {
  __typename?: 'Team';
  id: Scalars['ID'];
  name: Scalars['String'];
  keeperColor?: Maybe<Scalars['String']>;
  playerColor?: Maybe<Scalars['String']>;
  optaUid?: Maybe<Scalars['String']>;
};

export type TopicMapping = {
  in?: Maybe<Scalars['String']>;
  topic?: Maybe<Scalars['String']>;
};

export type TrackLabelTask = {
  __typename?: 'TrackLabelTask';
  id?: Maybe<Scalars['ID']>;
  start_frame: Scalars['Int'];
  end_frame: Scalars['Int'];
  start_x: Scalars['Float'];
  start_y: Scalars['Float'];
  start_z: Scalars['Float'];
  class_type: ClassType;
  lineupentry?: Maybe<LineupEntry>;
  owner?: Maybe<User>;
};

export type UpdateRoleInput = {
  name: Scalars['String'];
  privileges?: Maybe<Array<Maybe<Privilege>>>;
};

export type UpdateRoleOutput = {
  __typename?: 'UpdateRoleOutput';
  role?: Maybe<Role>;
};

export type UpdateSettingsInput = {
  defaultPipeline: Scalars['ID'];
};

export type UpdateUserInput = {
  id: Scalars['ID'];
  email: Scalars['String'];
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type UpdateUserOutput = {
  __typename?: 'UpdateUserOutput';
  user?: Maybe<User>;
};

export type User = {
  __typename?: 'User';
  id: Scalars['ID'];
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  account?: Maybe<Account>;
  accountEnabled?: Maybe<Scalars['Boolean']>;
  accountLocked?: Maybe<Scalars['Boolean']>;
  emailVerified?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Maybe<Role>>>;
};

export type Users = {
  __typename?: 'Users';
  users?: Maybe<Array<Maybe<User>>>;
  count: Scalars['Int'];
};

export type V1ContainerState = {
  __typename?: 'V1ContainerState';
  running?: Maybe<V1ContainerStateRunning>;
  terminated?: Maybe<V1ContainerStateTerminated>;
  waiting?: Maybe<V1ContainerStateWaiting>;
};

export type V1ContainerStateRunning = {
  __typename?: 'V1ContainerStateRunning';
  startedAt?: Maybe<Scalars['LocalDateTime']>;
};

export type V1ContainerStateTerminated = {
  __typename?: 'V1ContainerStateTerminated';
  containerID?: Maybe<Scalars['String']>;
  exitCode?: Maybe<Scalars['Int']>;
  finishedAt?: Maybe<Scalars['LocalDateTime']>;
  message?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  signal?: Maybe<Scalars['Int']>;
  startedAt?: Maybe<Scalars['LocalDateTime']>;
};

export type V1ContainerStateWaiting = {
  __typename?: 'V1ContainerStateWaiting';
  message?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
};

export type V1ContainerStatus = {
  __typename?: 'V1ContainerStatus';
  containerID?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  imageID?: Maybe<Scalars['String']>;
  lastState?: Maybe<V1ContainerState>;
  name?: Maybe<Scalars['String']>;
  ready?: Maybe<Scalars['Boolean']>;
  restartCount?: Maybe<Scalars['Int']>;
  state?: Maybe<V1ContainerState>;
};

export type V1PodCondition = {
  __typename?: 'V1PodCondition';
  /**
   * lastProbeTime: LocalDateTime
   * lastTransitionTime: LocalDateTime
   */
  message?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type V1PodStatus = {
  __typename?: 'V1PodStatus';
  conditions?: Maybe<Array<V1PodCondition>>;
  containerStatuses?: Maybe<Array<V1ContainerStatus>>;
  hostIP?: Maybe<Scalars['String']>;
  initContainerStatuses?: Maybe<Array<V1ContainerStatus>>;
  message?: Maybe<Scalars['String']>;
  nominatedNodeName?: Maybe<Scalars['String']>;
  phase?: Maybe<Scalars['String']>;
  podIP?: Maybe<Scalars['String']>;
  qosClass?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['LocalDateTime']>;
};

export type VideoInfo = {
  __typename?: 'VideoInfo';
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['Int']>;
  bitrate?: Maybe<Scalars['Int']>;
  fps?: Maybe<Scalars['Float']>;
  codec?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  syncOffset?: Maybe<Scalars['Int']>;
};

export type VideoInfoInput = {
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['Int']>;
  bitrate?: Maybe<Scalars['Int']>;
  fps?: Maybe<Scalars['Float']>;
  codec?: Maybe<Scalars['String']>;
  syncOffset?: Maybe<Scalars['Int']>;
};

export type VideoOrderInput = {
  id: Scalars['ID'];
  order: Scalars['Int'];
};

export enum VideoTranscodeState {
  Running = 'RUNNING',
  Failed = 'FAILED',
  Succeeded = 'SUCCEEDED',
  Copying = 'COPYING'
}

export type VideoTranscodeStatus = {
  __typename?: 'VideoTranscodeStatus';
  streamUrl?: Maybe<Scalars['String']>;
  state: VideoTranscodeState;
  error?: Maybe<Scalars['String']>;
};

export type AccountsQueryVariables = Exact<{
  search?: Maybe<Scalars['String']>;
  types?: Maybe<Array<AccountType> | AccountType>;
}>;


export type AccountsQuery = (
  { __typename?: 'Query' }
  & { accounts: (
    { __typename?: 'Accounts' }
    & { accounts: Array<(
      { __typename?: 'Account' }
      & AccountFragmentFragment
    )> }
  ) }
);

export type AccountQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AccountQuery = (
  { __typename?: 'Query' }
  & { account?: Maybe<(
    { __typename?: 'Account' }
    & AccountFragmentFragment
  )> }
);

export type AddAccountMutationVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
  accountType: AccountType;
}>;


export type AddAccountMutation = (
  { __typename?: 'Mutation' }
  & { addAccount?: Maybe<(
    { __typename?: 'Account' }
    & AccountFragmentFragment
  )> }
);

export type UpdateAccountMutationVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
}>;


export type UpdateAccountMutation = (
  { __typename?: 'Mutation' }
  & { updateAccount?: Maybe<(
    { __typename?: 'Account' }
    & AccountFragmentFragment
  )> }
);

export type DeleteAccountMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteAccountMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteAccount'>
);

export type AccountFragmentFragment = (
  { __typename?: 'Account' }
  & Pick<Account, 'id' | 'name' | 'bucket' | 'accountType'>
  & { users: Array<(
    { __typename?: 'User' }
    & Pick<User, 'firstname' | 'lastname' | 'email'>
  )> }
);

export type AuditLogsQueryVariables = Exact<{
  pagination?: Maybe<Pagination>;
  sorting?: Maybe<Array<Maybe<Sorting>> | Maybe<Sorting>>;
  search?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['Long']>;
  until?: Maybe<Scalars['Long']>;
  user?: Maybe<Scalars['ID']>;
  session?: Maybe<Scalars['ID']>;
  types?: Maybe<Array<AuditLogType> | AuditLogType>;
}>;


export type AuditLogsQuery = (
  { __typename?: 'Query' }
  & { auditlogs?: Maybe<(
    { __typename?: 'AuditLogs' }
    & Pick<AuditLogs, 'count'>
    & { logs?: Maybe<Array<(
      { __typename?: 'AuditLog' }
      & Pick<AuditLog, 'type' | 'timestamp' | 'params' | 'sessionid'>
      & { user?: Maybe<(
        { __typename?: 'User' }
        & Pick<User, 'id'>
      )> }
    )>> }
  )> }
);

export type PodsQueryVariables = Exact<{
  namespace: Scalars['String'];
  deployment: Scalars['String'];
}>;


export type PodsQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'pods'>
);

export type AllpipelinecomponentsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllpipelinecomponentsQuery = (
  { __typename?: 'Query' }
  & { pipelinecomponents?: Maybe<Array<(
    { __typename?: 'PipelineComponent' }
    & Pick<PipelineComponent, 'name' | 'version' | 'image' | 'id' | 'cpurequest' | 'memrequest' | 'gpurequest' | 'config_blob' | 'files' | 'ports' | 'inputs' | 'outputs' | 'replicas' | 'per_camera' | 'cpulimit' | 'memlimit' | 'postprocessing'>
    & { pipelines?: Maybe<Array<Maybe<(
      { __typename?: 'Pipeline' }
      & Pick<Pipeline, 'id'>
    )>>> }
  )>> }
);

export type AddPipelineComponentMutationVariables = Exact<{
  name: Scalars['String'];
  version: Scalars['String'];
  image: Scalars['String'];
  cpulimit: Scalars['String'];
  cpurequest: Scalars['String'];
  memlimit: Scalars['String'];
  memrequest: Scalars['String'];
  gpurequest: Scalars['Int'];
  replicas: Scalars['Int'];
  files?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  inputs?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  outputs?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  config_blob?: Maybe<Scalars['String']>;
  postprocessing: Scalars['Boolean'];
  ports?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  per_camera?: Maybe<Scalars['Boolean']>;
}>;


export type AddPipelineComponentMutation = (
  { __typename?: 'Mutation' }
  & { addPipelineComponent?: Maybe<(
    { __typename?: 'PipelineComponent' }
    & Pick<PipelineComponent, 'name' | 'version' | 'image' | 'id' | 'cpurequest' | 'memrequest' | 'gpurequest' | 'config_blob' | 'files' | 'ports' | 'inputs' | 'outputs' | 'replicas' | 'per_camera' | 'cpulimit' | 'memlimit' | 'postprocessing'>
  )> }
);

export type UpdatePipelineComponentMutationVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
  version: Scalars['String'];
  image: Scalars['String'];
  cpulimit: Scalars['String'];
  cpurequest: Scalars['String'];
  memlimit: Scalars['String'];
  memrequest: Scalars['String'];
  gpurequest: Scalars['Int'];
  replicas: Scalars['Int'];
  per_camera?: Maybe<Scalars['Boolean']>;
  files?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  inputs?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  outputs?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  config_blob?: Maybe<Scalars['String']>;
  postprocessing: Scalars['Boolean'];
  ports?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type UpdatePipelineComponentMutation = (
  { __typename?: 'Mutation' }
  & { updatePipelineComponent?: Maybe<(
    { __typename?: 'PipelineComponent' }
    & Pick<PipelineComponent, 'name' | 'version' | 'image' | 'id' | 'cpurequest' | 'memrequest' | 'gpurequest' | 'config_blob' | 'files' | 'ports' | 'inputs' | 'outputs' | 'replicas' | 'per_camera' | 'cpulimit' | 'memlimit' | 'postprocessing'>
  )> }
);

export type DeletePipelineComponentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeletePipelineComponentMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deletePipelineComponent'>
);

export type PipelinesQueryVariables = Exact<{ [key: string]: never; }>;


export type PipelinesQuery = (
  { __typename?: 'Query' }
  & { allpipelines?: Maybe<Array<(
    { __typename?: 'Pipeline' }
    & Pick<Pipeline, 'id' | 'name' | 'version' | 'created' | 'type'>
  )>> }
);

export type PipelineOverviewQueryVariables = Exact<{
  pagination?: Maybe<Pagination>;
  sorting?: Maybe<Array<Maybe<Sorting>> | Maybe<Sorting>>;
  versions?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
  search?: Maybe<Scalars['String']>;
  types?: Maybe<Array<Maybe<PipelineType>> | Maybe<PipelineType>>;
  components?: Maybe<Array<Maybe<Scalars['ID']>> | Maybe<Scalars['ID']>>;
  creationStart?: Maybe<Scalars['Long']>;
  creationEnd?: Maybe<Scalars['Long']>;
  lastRunStart?: Maybe<Scalars['Long']>;
  lastRunEnd?: Maybe<Scalars['Long']>;
}>;


export type PipelineOverviewQuery = (
  { __typename?: 'Query' }
  & { pipelines?: Maybe<(
    { __typename?: 'Pipelines' }
    & Pick<Pipelines, 'count'>
    & { pipelines?: Maybe<Array<(
      { __typename?: 'Pipeline' }
      & PipelineFragmentFragment
    )>> }
  )> }
);

export type PipelineQueryVariables = Exact<{
  pipeline: Scalars['ID'];
}>;


export type PipelineQuery = (
  { __typename?: 'Query' }
  & { pipeline?: Maybe<(
    { __typename?: 'Pipeline' }
    & Pick<Pipeline, 'id' | 'name' | 'created' | 'type' | 'version'>
    & { pipelineComponentSettings?: Maybe<Array<(
      { __typename?: 'PipelineComponentSettings' }
      & { pipelineComponent: (
        { __typename?: 'PipelineComponent' }
        & Pick<PipelineComponent, 'id' | 'name'>
      ), inputmap?: Maybe<Array<(
        { __typename?: 'Mapping' }
        & Pick<Mapping, 'in' | 'topic'>
      )>>, outputmap?: Maybe<Array<(
        { __typename?: 'Mapping' }
        & Pick<Mapping, 'in' | 'topic'>
      )>> }
    )>>, createdBy: (
      { __typename?: 'User' }
      & Pick<User, 'email'>
    ), runs?: Maybe<Array<(
      { __typename?: 'Run' }
      & Pick<Run, 'id'>
      & { status: (
        { __typename?: 'RunStatus' }
        & Pick<RunStatus, 'state'>
      ) }
    )>>, pipelinecomponents?: Maybe<Array<(
      { __typename?: 'PipelineComponent' }
      & Pick<PipelineComponent, 'id' | 'name' | 'version' | 'inputs' | 'outputs' | 'ports' | 'config_blob'>
    )>>, topics?: Maybe<Array<(
      { __typename?: 'PipelineTopic' }
      & Pick<PipelineTopic, 'partitions' | 'replication_factor' | 'per_camera' | 'topic' | 'compress'>
    )>> }
  )> }
);

export type PipelinecomponentsQueryVariables = Exact<{ [key: string]: never; }>;


export type PipelinecomponentsQuery = (
  { __typename?: 'Query' }
  & { pipelinecomponents?: Maybe<Array<(
    { __typename?: 'PipelineComponent' }
    & Pick<PipelineComponent, 'id' | 'name' | 'image' | 'version' | 'cpurequest' | 'memrequest' | 'replicas' | 'per_camera' | 'files' | 'ports' | 'inputs' | 'outputs' | 'config_blob'>
  )>> }
);

export type PipelinecomponentQueryVariables = Exact<{
  pipelinecomponentid: Scalars['ID'];
}>;


export type PipelinecomponentQuery = (
  { __typename?: 'Query' }
  & { pipelinecomponent?: Maybe<(
    { __typename?: 'PipelineComponent' }
    & Pick<PipelineComponent, 'name' | 'version' | 'image' | 'id' | 'cpurequest' | 'memrequest' | 'gpurequest' | 'config_blob' | 'files' | 'ports' | 'inputs' | 'outputs' | 'replicas' | 'per_camera' | 'cpulimit' | 'memlimit' | 'postprocessing'>
    & { pipelines?: Maybe<Array<Maybe<(
      { __typename?: 'Pipeline' }
      & Pick<Pipeline, 'id'>
      & { runs?: Maybe<Array<(
        { __typename?: 'Run' }
        & Pick<Run, 'id'>
        & { status: (
          { __typename?: 'RunStatus' }
          & Pick<RunStatus, 'state'>
        ) }
      )>> }
    )>>> }
  )> }
);

export type AddPipelineMutationVariables = Exact<{
  name: Scalars['String'];
  version: Scalars['String'];
  type: PipelineType;
  componentsettings?: Maybe<Array<ComponentSettingsInput> | ComponentSettingsInput>;
  pipelinecomponents?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  topics?: Maybe<Array<PipelineTopicInput> | PipelineTopicInput>;
}>;


export type AddPipelineMutation = (
  { __typename?: 'Mutation' }
  & { addPipeline?: Maybe<(
    { __typename?: 'Pipeline' }
    & PipelineFragmentFragment
  )> }
);

export type UpdatePipelineMutationVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
  version: Scalars['String'];
  type: PipelineType;
  componentsettings?: Maybe<Array<ComponentSettingsInput> | ComponentSettingsInput>;
  pipelinecomponents?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  topics?: Maybe<Array<PipelineTopicInput> | PipelineTopicInput>;
}>;


export type UpdatePipelineMutation = (
  { __typename?: 'Mutation' }
  & { updatePipeline?: Maybe<(
    { __typename?: 'Pipeline' }
    & PipelineFragmentFragment
  )> }
);

export type DeletePipelineMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeletePipelineMutation = (
  { __typename?: 'Mutation' }
  & { deletePipeline?: Maybe<(
    { __typename?: 'DeletePipelineOutput' }
    & Pick<DeletePipelineOutput, 'result'>
  )> }
);

export type PipelineFragmentFragment = (
  { __typename?: 'Pipeline' }
  & Pick<Pipeline, 'id' | 'name' | 'version' | 'type' | 'created'>
  & { createdBy: (
    { __typename?: 'User' }
    & Pick<User, 'firstname' | 'lastname'>
  ), pipelinecomponents?: Maybe<Array<(
    { __typename?: 'PipelineComponent' }
    & Pick<PipelineComponent, 'name' | 'version' | 'config_blob'>
  )>>, runs?: Maybe<Array<(
    { __typename?: 'Run' }
    & Pick<Run, 'bootTime'>
  )>> }
);

export type PitchesQueryVariables = Exact<{ [key: string]: never; }>;


export type PitchesQuery = (
  { __typename?: 'Query' }
  & { pitches?: Maybe<Array<(
    { __typename?: 'Pitch' }
    & PitchFragmentFragment
  )>> }
);

export type PitchQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PitchQuery = (
  { __typename?: 'Query' }
  & { pitch?: Maybe<(
    { __typename?: 'Pitch' }
    & PitchFragmentFragment
  )> }
);

export type AddPitchMutationVariables = Exact<{
  name: Scalars['String'];
  pitchType?: Maybe<Scalars['String']>;
  field_length: Scalars['Int'];
  field_width: Scalars['Int'];
  lat: Scalars['Float'];
  lng: Scalars['Float'];
}>;


export type AddPitchMutation = (
  { __typename?: 'Mutation' }
  & { addPitch?: Maybe<(
    { __typename?: 'Pitch' }
    & PitchFragmentFragment
  )> }
);

export type DeletePitchMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeletePitchMutation = (
  { __typename?: 'Mutation' }
  & { deletePitch?: Maybe<(
    { __typename?: 'DeletePitchOutput' }
    & Pick<DeletePitchOutput, 'result'>
  )> }
);

export type UpdatePitchMutationVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
  field_length: Scalars['Int'];
  field_width: Scalars['Int'];
  lat: Scalars['Float'];
  lng: Scalars['Float'];
  pitchType?: Maybe<Scalars['String']>;
}>;


export type UpdatePitchMutation = (
  { __typename?: 'Mutation' }
  & { updatePitch?: Maybe<(
    { __typename?: 'Pitch' }
    & PitchFragmentFragment
  )> }
);

export type PitchFragmentFragment = (
  { __typename?: 'Pitch' }
  & Pick<Pitch, 'id' | 'name' | 'pitchType' | 'timeZone' | 'field_length' | 'field_width' | 'lat' | 'lng' | 'generated'>
  & { sessions?: Maybe<Array<(
    { __typename?: 'Session' }
    & Pick<Session, 'id' | 'playedAt'>
    & { teamHome?: Maybe<(
      { __typename?: 'Team' }
      & Pick<Team, 'id' | 'name'>
    )>, teamAway?: Maybe<(
      { __typename?: 'Team' }
      & Pick<Team, 'id' | 'name'>
    )> }
  )>> }
);

export type PlayersQueryVariables = Exact<{
  team?: Maybe<Scalars['ID']>;
  search?: Maybe<Scalars['String']>;
}>;


export type PlayersQuery = (
  { __typename?: 'Query' }
  & { players?: Maybe<Array<(
    { __typename?: 'Player' }
    & PlayerInfoFragment
  )>> }
);

export type AddPlayerMutationVariables = Exact<{
  input: AddPlayerInput;
}>;


export type AddPlayerMutation = (
  { __typename?: 'Mutation' }
  & { addPlayer?: Maybe<(
    { __typename?: 'Player' }
    & PlayerInfoFragment
  )> }
);

export type PlayerInfoFragment = (
  { __typename?: 'Player' }
  & Pick<Player, 'id' | 'firstName' | 'lastName' | 'knownAs' | 'keeper' | 'lastKnownNumber' | 'optaUid'>
  & { lastKnownTeam?: Maybe<(
    { __typename?: 'Team' }
    & Pick<Team, 'id' | 'name'>
  )> }
);

export type RunsQueryVariables = Exact<{
  pagination?: Maybe<Pagination>;
  sorting?: Maybe<Array<Maybe<Sorting>> | Maybe<Sorting>>;
  search?: Maybe<Scalars['String']>;
  statuses?: Maybe<Array<RunState> | RunState>;
  creationStart?: Maybe<Scalars['Long']>;
  creationEnd?: Maybe<Scalars['Long']>;
  runStart?: Maybe<Scalars['Long']>;
  runEnd?: Maybe<Scalars['Long']>;
  completedOnly?: Maybe<Scalars['Boolean']>;
  pipelines?: Maybe<Array<Maybe<Scalars['ID']>> | Maybe<Scalars['ID']>>;
  pitches?: Maybe<Array<Maybe<Scalars['ID']>> | Maybe<Scalars['ID']>>;
}>;


export type RunsQuery = (
  { __typename?: 'Query' }
  & { runs?: Maybe<(
    { __typename?: 'Runs' }
    & Pick<Runs, 'count'>
    & { runs?: Maybe<Array<(
      { __typename?: 'Run' }
      & RunFieldsFragment
    )>> }
  )> }
);

export type RunQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
}>;


export type RunQuery = (
  { __typename?: 'Query' }
  & { run?: Maybe<(
    { __typename?: 'Run' }
    & RunFieldsFragment
  )> }
);

export type AddRunMutationVariables = Exact<{
  id: Scalars['ID'];
  kafka?: Maybe<Scalars['String']>;
  startTime: Scalars['Int'];
  session?: Maybe<Scalars['ID']>;
  pipeline?: Maybe<Scalars['ID']>;
  inputs?: Maybe<Array<Maybe<InputInput>> | Maybe<InputInput>>;
  pipelineSettings?: Maybe<Array<PipelineSettingInput> | PipelineSettingInput>;
}>;


export type AddRunMutation = (
  { __typename?: 'Mutation' }
  & { addRun?: Maybe<(
    { __typename?: 'Run' }
    & RunFieldsFragment
  )> }
);

export type UpdateRunMutationVariables = Exact<{
  id: Scalars['ID'];
  kafka?: Maybe<Scalars['String']>;
  startTime: Scalars['Int'];
  session?: Maybe<Scalars['ID']>;
  pipeline?: Maybe<Scalars['ID']>;
  inputs?: Maybe<Array<Maybe<InputInput>> | Maybe<InputInput>>;
  pipelineSettings?: Maybe<Array<PipelineSettingInput> | PipelineSettingInput>;
}>;


export type UpdateRunMutation = (
  { __typename?: 'Mutation' }
  & { updateRun?: Maybe<(
    { __typename?: 'Run' }
    & RunFieldsFragment
  )> }
);

export type RunFieldsFragment = (
  { __typename?: 'Run' }
  & Pick<Run, 'id' | 'startTime' | 'bootTime' | 'stopTime' | 'doneTime' | 'errorMessage' | 'kafka' | 'created'>
  & { inputs?: Maybe<Array<(
    { __typename?: 'Input' }
    & Pick<Input, 'input' | 'output'>
  )>>, createdBy?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'firstname' | 'lastname'>
  )>, status: (
    { __typename?: 'RunStatus' }
    & Pick<RunStatus, 'state'>
    & { components?: Maybe<Array<(
      { __typename?: 'ComponentStatus' }
      & { component: (
        { __typename?: 'PipelineComponent' }
        & Pick<PipelineComponent, 'id' | 'name' | 'version'>
      ), state: (
        { __typename?: 'ComponentState' }
        & Pick<ComponentState, 'replicas' | 'state'>
      ) }
    )>> }
  ), session?: Maybe<(
    { __typename?: 'Session' }
    & Pick<Session, 'id' | 'name' | 'addSecondsOffset'>
    & { pitch?: Maybe<(
      { __typename?: 'Pitch' }
      & Pick<Pitch, 'id' | 'name' | 'timeZone'>
    )>, teamHome?: Maybe<(
      { __typename?: 'Team' }
      & Pick<Team, 'id' | 'name'>
    )>, teamAway?: Maybe<(
      { __typename?: 'Team' }
      & Pick<Team, 'id' | 'name'>
    )>, periods?: Maybe<Array<(
      { __typename?: 'SessionPeriod' }
      & Pick<SessionPeriod, 'id' | 'type' | 'startTime' | 'endTime'>
    )>>, videos?: Maybe<Array<(
      { __typename?: 'SessionVideo' }
      & Pick<SessionVideo, 'calibration' | 'clickPoints' | 'sortOrder' | 'url' | 'id' | 'ip'>
      & { videoInfo?: Maybe<(
        { __typename?: 'VideoInfo' }
        & Pick<VideoInfo, 'url' | 'width' | 'height' | 'fps' | 'bitrate' | 'duration' | 'codec' | 'syncOffset'>
      )>, transcodeStatus?: Maybe<(
        { __typename?: 'VideoTranscodeStatus' }
        & Pick<VideoTranscodeStatus, 'streamUrl' | 'state' | 'error'>
      )> }
    )>> }
  )>, pipeline: (
    { __typename?: 'Pipeline' }
    & Pick<Pipeline, 'id' | 'name' | 'version'>
  ), pipelineSettings?: Maybe<Array<(
    { __typename?: 'PipelineSetting' }
    & Pick<PipelineSetting, 'setting' | 'value'>
    & { plc: (
      { __typename?: 'PipelineComponent' }
      & Pick<PipelineComponent, 'id' | 'name'>
    ) }
  )>> }
);

export type StartrunMutationVariables = Exact<{
  runid?: Maybe<Scalars['ID']>;
}>;


export type StartrunMutation = (
  { __typename?: 'Mutation' }
  & { startRun?: Maybe<(
    { __typename?: 'Run' }
    & Pick<Run, 'id'>
    & { status: (
      { __typename?: 'RunStatus' }
      & Pick<RunStatus, 'state'>
    ) }
  )> }
);

export type DeleteDataMutationVariables = Exact<{
  runid?: Maybe<Scalars['ID']>;
}>;


export type DeleteDataMutation = (
  { __typename?: 'Mutation' }
  & { deleteData?: Maybe<(
    { __typename?: 'RunStatus' }
    & Pick<RunStatus, 'runid'>
  )> }
);

export type StoprunMutationVariables = Exact<{
  runid?: Maybe<Scalars['ID']>;
}>;


export type StoprunMutation = (
  { __typename?: 'Mutation' }
  & { stopRun?: Maybe<(
    { __typename?: 'Run' }
    & { status: (
      { __typename?: 'RunStatus' }
      & Pick<RunStatus, 'state'>
    ) }
  )> }
);

export type DeleterunMutationVariables = Exact<{
  runid?: Maybe<Scalars['ID']>;
}>;


export type DeleterunMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteRun'>
);

export type ResetRunMutationVariables = Exact<{
  runid?: Maybe<Scalars['ID']>;
}>;


export type ResetRunMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'resetRun'>
);

export type RunStatusQueryVariables = Exact<{
  runid: Scalars['ID'];
}>;


export type RunStatusQuery = (
  { __typename?: 'Query' }
  & { runStatus?: Maybe<(
    { __typename?: 'RunStatus' }
    & Pick<RunStatus, 'runid'>
  )> }
);

export type ComponentStatusQueryVariables = Exact<{
  runid: Scalars['String'];
  component: Scalars['String'];
}>;


export type ComponentStatusQuery = (
  { __typename?: 'Query' }
  & { componentStatus: (
    { __typename?: 'ComponentStatus' }
    & { component: (
      { __typename?: 'PipelineComponent' }
      & Pick<PipelineComponent, 'id' | 'name' | 'image' | 'version' | 'cpulimit' | 'memlimit' | 'gpurequest' | 'replicas' | 'postprocessing' | 'ports'>
    ), state: (
      { __typename?: 'ComponentState' }
      & Pick<ComponentState, 'state' | 'replicas'>
    ), instances?: Maybe<Array<(
      { __typename?: 'InstanceState' }
      & Pick<InstanceState, 'pod' | 'log'>
      & { status: (
        { __typename?: 'V1PodStatus' }
        & Pick<V1PodStatus, 'hostIP' | 'message' | 'nominatedNodeName' | 'phase' | 'podIP' | 'qosClass' | 'reason' | 'startTime'>
        & { conditions?: Maybe<Array<(
          { __typename?: 'V1PodCondition' }
          & Pick<V1PodCondition, 'message' | 'reason' | 'status' | 'type'>
        )>>, containerStatuses?: Maybe<Array<(
          { __typename?: 'V1ContainerStatus' }
          & ContainerStatusFragment
        )>>, initContainerStatuses?: Maybe<Array<(
          { __typename?: 'V1ContainerStatus' }
          & ContainerStatusFragment
        )>> }
      ) }
    )>> }
  ) }
);

export type ContainerStatusFragment = (
  { __typename?: 'V1ContainerStatus' }
  & Pick<V1ContainerStatus, 'containerID' | 'image' | 'imageID' | 'name' | 'ready' | 'restartCount'>
  & { lastState?: Maybe<(
    { __typename?: 'V1ContainerState' }
    & ContainerStateFragment
  )>, state?: Maybe<(
    { __typename?: 'V1ContainerState' }
    & ContainerStateFragment
  )> }
);

export type ContainerStateFragment = (
  { __typename?: 'V1ContainerState' }
  & { running?: Maybe<(
    { __typename?: 'V1ContainerStateRunning' }
    & Pick<V1ContainerStateRunning, 'startedAt'>
  )>, terminated?: Maybe<(
    { __typename?: 'V1ContainerStateTerminated' }
    & Pick<V1ContainerStateTerminated, 'containerID' | 'exitCode' | 'finishedAt' | 'message' | 'reason' | 'signal' | 'startedAt'>
  )>, waiting?: Maybe<(
    { __typename?: 'V1ContainerStateWaiting' }
    & Pick<V1ContainerStateWaiting, 'message' | 'reason'>
  )> }
);

export type SessionQueryVariables = Exact<{
  sessionid: Scalars['ID'];
}>;


export type SessionQuery = (
  { __typename?: 'Query' }
  & { session?: Maybe<(
    { __typename?: 'Session' }
    & SessionPropsFragment
  )> }
);

export type VideoInfoQueryVariables = Exact<{
  url: Scalars['String'];
}>;


export type VideoInfoQuery = (
  { __typename?: 'Query' }
  & { videoInfo?: Maybe<(
    { __typename?: 'VideoInfo' }
    & Pick<VideoInfo, 'url' | 'width' | 'height' | 'codec' | 'fps' | 'duration' | 'bitrate' | 'error'>
  )> }
);

export type SnapshotQueryVariables = Exact<{
  video: Scalars['ID'];
}>;


export type SnapshotQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'snapshot'>
);

export type SessionVideoQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SessionVideoQuery = (
  { __typename?: 'Query' }
  & { sessionVideo?: Maybe<(
    { __typename?: 'SessionVideo' }
    & SessionVideoPropsFragment
  )> }
);

export type SessionsQueryVariables = Exact<{
  pagination?: Maybe<Pagination>;
  sorting?: Maybe<Array<Maybe<Sorting>> | Maybe<Sorting>>;
  search?: Maybe<Scalars['String']>;
  creationStart?: Maybe<Scalars['Long']>;
  creationEnd?: Maybe<Scalars['Long']>;
  pitches?: Maybe<Array<Maybe<Scalars['ID']>> | Maybe<Scalars['ID']>>;
  approved?: Maybe<Scalars['Boolean']>;
}>;


export type SessionsQuery = (
  { __typename?: 'Query' }
  & { sessions?: Maybe<(
    { __typename?: 'Sessions' }
    & Pick<Sessions, 'count'>
    & { sessions?: Maybe<Array<(
      { __typename?: 'Session' }
      & SessionPropsFragment
    )>> }
  )> }
);

export type AllsessionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllsessionsQuery = (
  { __typename?: 'Query' }
  & { allsessions?: Maybe<Array<(
    { __typename?: 'Session' }
    & SessionPropsFragment
  )>> }
);

export type SessionResultQueryVariables = Exact<{
  sessionid: Scalars['ID'];
}>;


export type SessionResultQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'sessionResult'>
);

export type AddSessionMutationVariables = Exact<{
  input?: Maybe<AddSessionInput>;
}>;


export type AddSessionMutation = (
  { __typename?: 'Mutation' }
  & { addSession?: Maybe<(
    { __typename?: 'Session' }
    & SessionPropsFragment
  )> }
);

export type UpdateSessionMutationVariables = Exact<{
  id: Scalars['ID'];
  input?: Maybe<AddSessionInput>;
}>;


export type UpdateSessionMutation = (
  { __typename?: 'Mutation' }
  & { updateSession?: Maybe<(
    { __typename?: 'Session' }
    & SessionPropsFragment
  )> }
);

export type DeleteSessionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteSessionMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteSession'>
);

export type StartSessionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type StartSessionMutation = (
  { __typename?: 'Mutation' }
  & { startSession?: Maybe<(
    { __typename?: 'Session' }
    & SessionPropsFragment
  )> }
);

export type UpdateCalibrationMutationVariables = Exact<{
  id: Scalars['ID'];
  calibration: Scalars['String'];
  clickpoints: Scalars['String'];
}>;


export type UpdateCalibrationMutation = (
  { __typename?: 'Mutation' }
  & { updateCalibration?: Maybe<(
    { __typename?: 'SessionVideo' }
    & SessionVideoPropsFragment
  )> }
);

export type SessionAddEventMutationVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  input: AddSessionEventInput;
}>;


export type SessionAddEventMutation = (
  { __typename?: 'Mutation' }
  & { sessionAddEvent?: Maybe<(
    { __typename?: 'Session' }
    & SessionPropsFragment
  )> }
);

export type SessionUpdateEventMutationVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  input: AddSessionEventInput;
}>;


export type SessionUpdateEventMutation = (
  { __typename?: 'Mutation' }
  & { sessionUpdateEvent?: Maybe<(
    { __typename?: 'Session' }
    & SessionPropsFragment
  )> }
);

export type SessionDeleteEventMutationVariables = Exact<{
  sessionid: Scalars['ID'];
  eventid: Scalars['ID'];
}>;


export type SessionDeleteEventMutation = (
  { __typename?: 'Mutation' }
  & { sessionDeleteEvent?: Maybe<(
    { __typename?: 'Session' }
    & SessionPropsFragment
  )> }
);

export type SessionAddPeriodMutationVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  input: AddSessionPeriodInput;
}>;


export type SessionAddPeriodMutation = (
  { __typename?: 'Mutation' }
  & { sessionAddPeriod?: Maybe<(
    { __typename?: 'Session' }
    & SessionPropsFragment
  )> }
);

export type SessionUpdatePeriodMutationVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  input: AddSessionPeriodInput;
}>;


export type SessionUpdatePeriodMutation = (
  { __typename?: 'Mutation' }
  & { sessionUpdatePeriod?: Maybe<(
    { __typename?: 'Session' }
    & SessionPropsFragment
  )> }
);

export type SessionDeletePeriodMutationVariables = Exact<{
  sessionid: Scalars['ID'];
  periodid: Scalars['ID'];
}>;


export type SessionDeletePeriodMutation = (
  { __typename?: 'Mutation' }
  & { sessionDeletePeriod?: Maybe<(
    { __typename?: 'Session' }
    & SessionPropsFragment
  )> }
);

export type SessionAddLabelPositionMutationVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  input: AddSessionLabelPositionInput;
}>;


export type SessionAddLabelPositionMutation = (
  { __typename?: 'Mutation' }
  & { sessionAddLabelPosition?: Maybe<(
    { __typename?: 'Session' }
    & SessionPropsFragment
  )> }
);

export type SessionDeleteLabelPositionsMutationVariables = Exact<{
  sessionid: Scalars['ID'];
  labelPositionIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type SessionDeleteLabelPositionsMutation = (
  { __typename?: 'Mutation' }
  & { sessionDeleteLabelPositions?: Maybe<(
    { __typename?: 'Session' }
    & SessionPropsFragment
  )> }
);

export type SessionUpdateTrackLabelTaskMutationVariables = Exact<{
  id: Scalars['ID'];
  input: AddTrackLabelTaskInput;
}>;


export type SessionUpdateTrackLabelTaskMutation = (
  { __typename?: 'Mutation' }
  & { sessionUpdateTrackLabelTask?: Maybe<(
    { __typename?: 'Session' }
    & SessionPropsFragment
  )> }
);

export type SessionAddTrackLabelTasksMutationVariables = Exact<{
  id: Scalars['ID'];
  input?: Maybe<Array<AddTrackLabelTaskInput> | AddTrackLabelTaskInput>;
}>;


export type SessionAddTrackLabelTasksMutation = (
  { __typename?: 'Mutation' }
  & { sessionAddTrackLabelTasks?: Maybe<(
    { __typename?: 'Session' }
    & SessionPropsFragment
  )> }
);

export type SessionDeleteTrackLabelTaskMutationVariables = Exact<{
  sessionid: Scalars['ID'];
  taskId: Scalars['ID'];
}>;


export type SessionDeleteTrackLabelTaskMutation = (
  { __typename?: 'Mutation' }
  & { sessionDeleteTrackLabelTask?: Maybe<(
    { __typename?: 'Session' }
    & SessionPropsFragment
  )> }
);

export type SessionClearTrackLabelTasksMutationVariables = Exact<{
  sessionid: Scalars['ID'];
}>;


export type SessionClearTrackLabelTasksMutation = (
  { __typename?: 'Mutation' }
  & { sessionClearTrackLabelTasks?: Maybe<(
    { __typename?: 'Session' }
    & SessionPropsFragment
  )> }
);

export type SessionUpdateVideoMutationVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  input: AddSessionVideoInput;
}>;


export type SessionUpdateVideoMutation = (
  { __typename?: 'Mutation' }
  & { sessionUpdateVideo?: Maybe<(
    { __typename?: 'Session' }
    & SessionPropsFragment
  )> }
);

export type SessionAddVideoMutationVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  input: AddSessionVideoInput;
}>;


export type SessionAddVideoMutation = (
  { __typename?: 'Mutation' }
  & { sessionAddVideo?: Maybe<(
    { __typename?: 'Session' }
    & SessionPropsFragment
  )> }
);

export type SessionDeleteVideoMutationVariables = Exact<{
  sessionid: Scalars['ID'];
  videoId: Scalars['ID'];
}>;


export type SessionDeleteVideoMutation = (
  { __typename?: 'Mutation' }
  & { sessionDeleteVideo?: Maybe<(
    { __typename?: 'Session' }
    & SessionPropsFragment
  )> }
);

export type UpdateVideoOrderMutationVariables = Exact<{
  sessionid: Scalars['ID'];
  order: Array<VideoOrderInput> | VideoOrderInput;
}>;


export type UpdateVideoOrderMutation = (
  { __typename?: 'Mutation' }
  & { updateVideoOrder?: Maybe<(
    { __typename?: 'Session' }
    & SessionPropsFragment
  )> }
);

export type UpdateCalibrationImageMutationVariables = Exact<{
  id: Scalars['ID'];
  calibrationImage: Scalars['String'];
}>;


export type UpdateCalibrationImageMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'updateCalibrationImage'>
);

export type MatchingVideoQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MatchingVideoQuery = (
  { __typename?: 'Query' }
  & { matchingVideo?: Maybe<(
    { __typename?: 'SessionVideo' }
    & SessionVideoPropsFragment
  )> }
);

export type ImportOptaF7MutationVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  xml: Scalars['String'];
}>;


export type ImportOptaF7Mutation = (
  { __typename?: 'Mutation' }
  & { importOptaF7?: Maybe<(
    { __typename?: 'Session' }
    & SessionPropsFragment
  )> }
);

export type AddUpdateLineupMutationVariables = Exact<{
  id: Scalars['ID'];
  lineup?: Maybe<Array<AddLineupEntryInput> | AddLineupEntryInput>;
}>;


export type AddUpdateLineupMutation = (
  { __typename?: 'Mutation' }
  & { sessionAddUpdateLineup?: Maybe<(
    { __typename?: 'Session' }
    & SessionPropsFragment
  )> }
);

export type ExportEptsMutationVariables = Exact<{
  id: Scalars['ID'];
  autonomous: Scalars['Boolean'];
}>;


export type ExportEptsMutation = (
  { __typename?: 'Mutation' }
  & { exportEpts?: Maybe<(
    { __typename?: 'Session' }
    & SessionPropsFragment
  )> }
);

export type LabelTaskQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LabelTaskQuery = (
  { __typename?: 'Query' }
  & { labelTask?: Maybe<(
    { __typename?: 'TrackLabelTask' }
    & LabelTaskPropsFragment
  )> }
);

export type LabelTaskPropsFragment = (
  { __typename?: 'TrackLabelTask' }
  & Pick<TrackLabelTask, 'id' | 'start_frame' | 'end_frame' | 'start_x' | 'start_y' | 'start_z' | 'class_type'>
  & { owner?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'firstname' | 'lastname'>
  )>, lineupentry?: Maybe<(
    { __typename?: 'LineupEntry' }
    & LineupEntryPropsFragment
  )> }
);

export type SessionVideoPropsFragment = (
  { __typename?: 'SessionVideo' }
  & Pick<SessionVideo, 'sortOrder' | 'url' | 'id' | 'calibration' | 'clickPoints'>
  & { videoInfo?: Maybe<(
    { __typename?: 'VideoInfo' }
    & Pick<VideoInfo, 'url' | 'width' | 'height' | 'fps' | 'bitrate' | 'duration' | 'codec' | 'syncOffset'>
  )>, transcodeStatus?: Maybe<(
    { __typename?: 'VideoTranscodeStatus' }
    & Pick<VideoTranscodeStatus, 'streamUrl' | 'state' | 'error'>
  )> }
);

export type SessionPropsFragment = (
  { __typename?: 'Session' }
  & Pick<Session, 'id' | 'name' | 'label' | 'addSecondsOffset' | 'location' | 'playedAt' | 'createdAt' | 'startedAt' | 'finishedAt' | 'teamHomeKeeperColor' | 'teamHomePlayersColor' | 'teamAwayKeeperColor' | 'teamAwayPlayersColor' | 'refereeColor' | 'competition' | 'keepData' | 'fullID' | 'nrPlayers' | 'nrKeepers' | 'homeScore' | 'awayScore' | 'approved' | 'matchInfoUrl'>
  & { account: (
    { __typename?: 'Account' }
    & Pick<Account, 'id'>
  ), labelAccount?: Maybe<(
    { __typename?: 'Account' }
    & Pick<Account, 'id'>
  )>, lineup?: Maybe<Array<(
    { __typename?: 'LineupEntry' }
    & LineupEntryPropsFragment
  )>>, teamHome?: Maybe<(
    { __typename?: 'Team' }
    & Pick<Team, 'id' | 'name' | 'keeperColor' | 'playerColor'>
  )>, teamAway?: Maybe<(
    { __typename?: 'Team' }
    & Pick<Team, 'id' | 'name' | 'keeperColor' | 'playerColor'>
  )>, createdBy: (
    { __typename?: 'User' }
    & Pick<User, 'id'>
  ), pitch?: Maybe<(
    { __typename?: 'Pitch' }
    & Pick<Pitch, 'id' | 'name' | 'field_length' | 'field_width'>
  )>, videos?: Maybe<Array<(
    { __typename?: 'SessionVideo' }
    & Pick<SessionVideo, 'calibration' | 'clickPoints' | 'sortOrder' | 'url' | 'id' | 'ip'>
    & { videoInfo?: Maybe<(
      { __typename?: 'VideoInfo' }
      & Pick<VideoInfo, 'url' | 'width' | 'height' | 'fps' | 'bitrate' | 'duration' | 'codec' | 'syncOffset'>
    )>, transcodeStatus?: Maybe<(
      { __typename?: 'VideoTranscodeStatus' }
      & Pick<VideoTranscodeStatus, 'streamUrl' | 'state' | 'error'>
    )> }
  )>>, labelPositions?: Maybe<Array<(
    { __typename?: 'SessionLabelPosition' }
    & Pick<SessionLabelPosition, 'id' | 'videoTime' | 'classType' | 'x' | 'y' | 'z'>
  )>>, labelTasks?: Maybe<Array<(
    { __typename?: 'TrackLabelTask' }
    & LabelTaskPropsFragment
  )>>, pipeline?: Maybe<(
    { __typename?: 'Pipeline' }
    & Pick<Pipeline, 'id'>
  )>, periods?: Maybe<Array<(
    { __typename?: 'SessionPeriod' }
    & Pick<SessionPeriod, 'id' | 'type' | 'label' | 'startTime' | 'endTime'>
    & { teamLeft?: Maybe<(
      { __typename?: 'Team' }
      & Pick<Team, 'id' | 'name'>
    )> }
  )>>, events?: Maybe<Array<(
    { __typename?: 'SessionEvent' }
    & Pick<SessionEvent, 'id' | 'timestamp' | 'type' | 'reason' | 'offscreen'>
    & { team?: Maybe<(
      { __typename?: 'Team' }
      & Pick<Team, 'id' | 'name'>
    )>, in?: Maybe<(
      { __typename?: 'SessionPlayer' }
      & Pick<SessionPlayer, 'id' | 'type' | 'number'>
    )>, out?: Maybe<(
      { __typename?: 'SessionPlayer' }
      & Pick<SessionPlayer, 'id' | 'type' | 'number'>
    )> }
  )>>, lastRun?: Maybe<(
    { __typename?: 'Run' }
    & Pick<Run, 'id' | 'errorMessage' | 'runExportStatus'>
    & { saveRunStatus?: Maybe<(
      { __typename?: 'SaveRunStatus' }
      & Pick<SaveRunStatus, 'percent_completed'>
    )>, exportStatus?: Maybe<(
      { __typename?: 'ExportStatus' }
      & Pick<ExportStatus, 'progress' | 'state' | 'finish_state'>
    )>, status: (
      { __typename?: 'RunStatus' }
      & Pick<RunStatus, 'state'>
    ), session?: Maybe<(
      { __typename?: 'Session' }
      & Pick<Session, 'addSecondsOffset'>
      & { periods?: Maybe<Array<(
        { __typename?: 'SessionPeriod' }
        & Pick<SessionPeriod, 'id' | 'startTime' | 'endTime'>
      )>>, videos?: Maybe<Array<(
        { __typename?: 'SessionVideo' }
        & { videoInfo?: Maybe<(
          { __typename?: 'VideoInfo' }
          & Pick<VideoInfo, 'fps'>
        )> }
      )>> }
    )> }
  )> }
);

export type PlayerFieldsFragment = (
  { __typename?: 'Player' }
  & Pick<Player, 'id' | 'firstName' | 'lastName' | 'knownAs' | 'keeper' | 'lastKnownNumber'>
  & { lastKnownTeam?: Maybe<(
    { __typename?: 'Team' }
    & Pick<Team, 'id'>
  )> }
);

export type LineupEntryPropsFragment = (
  { __typename?: 'LineupEntry' }
  & Pick<LineupEntry, 'id' | 'type' | 'periodIn' | 'periodOut' | 'inSeconds' | 'outSeconds' | 'shirtNumber' | 'reason'>
  & { player?: Maybe<(
    { __typename?: 'Player' }
    & PlayerFieldsFragment
  )>, substituted?: Maybe<(
    { __typename?: 'Player' }
    & PlayerFieldsFragment
  )>, inEvent?: Maybe<(
    { __typename?: 'SessionEvent' }
    & Pick<SessionEvent, 'id' | 'timestamp' | 'reason' | 'offscreen'>
  )>, outEvent?: Maybe<(
    { __typename?: 'SessionEvent' }
    & Pick<SessionEvent, 'id' | 'timestamp' | 'reason' | 'offscreen'>
  )>, dataFrames?: Maybe<Array<(
    { __typename?: 'LineupEntryFrame' }
    & Pick<LineupEntryFrame, 'first' | 'last'>
  )>> }
);

export type UpdateSettingsMutationVariables = Exact<{
  settings: UpdateSettingsInput;
}>;


export type UpdateSettingsMutation = (
  { __typename?: 'Mutation' }
  & { updateSettings?: Maybe<(
    { __typename?: 'Settings' }
    & SettingsFragmentFragment
  )> }
);

export type SettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type SettingsQuery = (
  { __typename?: 'Query' }
  & { settings?: Maybe<(
    { __typename?: 'Settings' }
    & SettingsFragmentFragment
  )> }
);

export type SettingsFragmentFragment = (
  { __typename?: 'Settings' }
  & Pick<Settings, 'id' | 'sessionsBucket' | 'frontendVersion' | 'apiVersion'>
  & { defaultPipeline?: Maybe<(
    { __typename?: 'Pipeline' }
    & Pick<Pipeline, 'id'>
  )> }
);

export type TeamsQueryVariables = Exact<{ [key: string]: never; }>;


export type TeamsQuery = (
  { __typename?: 'Query' }
  & { teams?: Maybe<Array<(
    { __typename?: 'Team' }
    & TeamInfoFragment
  )>> }
);

export type AddTeamMutationVariables = Exact<{
  input: AddTeamInput;
}>;


export type AddTeamMutation = (
  { __typename?: 'Mutation' }
  & { addTeam?: Maybe<(
    { __typename?: 'Team' }
    & TeamInfoFragment
  )> }
);

export type TeamInfoFragment = (
  { __typename?: 'Team' }
  & Pick<Team, 'id' | 'name' | 'keeperColor' | 'playerColor'>
);

export type LoginMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginMutation = (
  { __typename?: 'Mutation' }
  & { login?: Maybe<(
    { __typename?: 'LoginOutput' }
    & { user?: Maybe<(
      { __typename?: 'User' }
      & UserFragmentFragment
    )> }
  )> }
);

export type LoginTokenMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type LoginTokenMutation = (
  { __typename?: 'Mutation' }
  & { loginToken?: Maybe<(
    { __typename?: 'LoginTokenOutput' }
    & { user?: Maybe<(
      { __typename?: 'User' }
      & UserFragmentFragment
    )> }
  )> }
);

export type ResetPasswordMutationVariables = Exact<{
  newpassword: Scalars['String'];
}>;


export type ResetPasswordMutation = (
  { __typename?: 'Mutation' }
  & { resetPassword?: Maybe<(
    { __typename?: 'ResetPasswordOutput' }
    & { user?: Maybe<(
      { __typename?: 'User' }
      & UserFragmentFragment
    )> }
  )> }
);

export type ConfirmRegistrationMutationVariables = Exact<{
  password: Scalars['String'];
}>;


export type ConfirmRegistrationMutation = (
  { __typename?: 'Mutation' }
  & { confirmRegistration?: Maybe<(
    { __typename?: 'ConfirmRegistrationOutput' }
    & { user?: Maybe<(
      { __typename?: 'User' }
      & UserFragmentFragment
    )> }
  )> }
);

export type CreateUserMutationVariables = Exact<{
  email: Scalars['String'];
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  account: Scalars['String'];
  roles?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type CreateUserMutation = (
  { __typename?: 'Mutation' }
  & { createUser?: Maybe<(
    { __typename?: 'CreateUserOutput' }
    & Pick<CreateUserOutput, 'error'>
    & { user?: Maybe<(
      { __typename?: 'User' }
      & UserFragmentFragment
    )> }
  )> }
);

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['ID'];
  email: Scalars['String'];
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  roles?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type UpdateUserMutation = (
  { __typename?: 'Mutation' }
  & { updateUser?: Maybe<(
    { __typename?: 'UpdateUserOutput' }
    & { user?: Maybe<(
      { __typename?: 'User' }
      & UserFragmentFragment
    )> }
  )> }
);

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteUserMutation = (
  { __typename?: 'Mutation' }
  & { deleteUser?: Maybe<(
    { __typename?: 'DeleteUserOutput' }
    & Pick<DeleteUserOutput, 'result'>
  )> }
);

export type ResendInviteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ResendInviteMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'resendInvite'>
);

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = (
  { __typename?: 'Query' }
  & { me?: Maybe<(
    { __typename?: 'User' }
    & UserFragmentFragment
  )> }
);

export type UserQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserQuery = (
  { __typename?: 'Query' }
  & { user?: Maybe<(
    { __typename?: 'User' }
    & UserFragmentFragment
  )> }
);

export type RolesQueryVariables = Exact<{ [key: string]: never; }>;


export type RolesQuery = (
  { __typename?: 'Query' }
  & { roles?: Maybe<(
    { __typename?: 'Roles' }
    & { roles?: Maybe<Array<Maybe<(
      { __typename?: 'Role' }
      & Pick<Role, 'name' | 'privileges'>
    )>>> }
  )> }
);

export type AllUsersQueryVariables = Exact<{
  pagination?: Maybe<Pagination>;
  sorting?: Maybe<Array<Maybe<Sorting>> | Maybe<Sorting>>;
  search?: Maybe<Scalars['String']>;
  account?: Maybe<Scalars['String']>;
}>;


export type AllUsersQuery = (
  { __typename?: 'Query' }
  & { allUsers?: Maybe<(
    { __typename?: 'Users' }
    & Pick<Users, 'count'>
    & { users?: Maybe<Array<Maybe<(
      { __typename?: 'User' }
      & UserFragmentFragment
    )>>> }
  )> }
);

export type UsersQueryVariables = Exact<{ [key: string]: never; }>;


export type UsersQuery = (
  { __typename?: 'Query' }
  & { users?: Maybe<Array<(
    { __typename?: 'User' }
    & UserFragmentFragment
  )>> }
);

export type UserFragmentFragment = (
  { __typename?: 'User' }
  & Pick<User, 'id' | 'email' | 'firstname' | 'lastname' | 'accountEnabled' | 'accountLocked' | 'emailVerified'>
  & { account?: Maybe<(
    { __typename?: 'Account' }
    & Pick<Account, 'id'>
  )>, roles?: Maybe<Array<Maybe<(
    { __typename?: 'Role' }
    & Pick<Role, 'name' | 'privileges'>
  )>>> }
);

export const AccountFragmentFragmentDoc = gql`
    fragment accountFragment on Account {
  id
  name
  bucket
  accountType
  users {
    firstname
    lastname
    email
  }
}
    `;
export const PipelineFragmentFragmentDoc = gql`
    fragment pipelineFragment on Pipeline {
  id
  name
  version
  type
  created
  createdBy {
    firstname
    lastname
  }
  pipelinecomponents {
    name
    version
    config_blob
  }
  runs {
    bootTime
  }
}
    `;
export const PitchFragmentFragmentDoc = gql`
    fragment pitchFragment on Pitch {
  id
  name
  pitchType
  timeZone
  field_length
  field_width
  lat
  lng
  generated
  sessions {
    id
    playedAt
    teamHome {
      id
      name
    }
    teamAway {
      id
      name
    }
  }
}
    `;
export const PlayerInfoFragmentDoc = gql`
    fragment playerInfo on Player {
  id
  firstName
  lastName
  knownAs
  keeper
  lastKnownTeam {
    id
    name
  }
  lastKnownNumber
  optaUid
}
    `;
export const RunFieldsFragmentDoc = gql`
    fragment runFields on Run {
  id
  startTime
  bootTime
  stopTime
  doneTime
  errorMessage
  kafka
  inputs {
    input
    output
  }
  created
  createdBy {
    id
    firstname
    lastname
  }
  status {
    state
    components {
      component {
        id
        name
        version
      }
      state {
        replicas
        state
      }
    }
  }
  session {
    id
    name
    addSecondsOffset
    pitch {
      id
      name
      timeZone
    }
    teamHome {
      id
      name
    }
    teamAway {
      id
      name
    }
    periods {
      id
      type
      startTime
      endTime
    }
    videos {
      videoInfo {
        url
        width
        height
        fps
        bitrate
        duration
        codec
        syncOffset
      }
      calibration
      clickPoints
      sortOrder
      url
      id
      transcodeStatus {
        streamUrl
        state
        error
      }
      ip
    }
  }
  pipeline {
    id
    name
    version
  }
  pipelineSettings {
    plc {
      id
      name
    }
    setting
    value
  }
}
    `;
export const ContainerStateFragmentDoc = gql`
    fragment containerState on V1ContainerState {
  running {
    startedAt
  }
  terminated {
    containerID
    exitCode
    finishedAt
    message
    reason
    signal
    startedAt
  }
  waiting {
    message
    reason
  }
}
    `;
export const ContainerStatusFragmentDoc = gql`
    fragment containerStatus on V1ContainerStatus {
  containerID
  image
  imageID
  lastState {
    ...containerState
  }
  name
  ready
  restartCount
  state {
    ...containerState
  }
}
    ${ContainerStateFragmentDoc}`;
export const SessionVideoPropsFragmentDoc = gql`
    fragment sessionVideoProps on SessionVideo {
  videoInfo {
    url
    width
    height
    fps
    bitrate
    duration
    codec
    syncOffset
  }
  sortOrder
  url
  id
  transcodeStatus {
    streamUrl
    state
    error
  }
  calibration
  clickPoints
}
    `;
export const PlayerFieldsFragmentDoc = gql`
    fragment playerFields on Player {
  id
  firstName
  lastName
  knownAs
  keeper
  lastKnownTeam {
    id
  }
  lastKnownNumber
}
    `;
export const LineupEntryPropsFragmentDoc = gql`
    fragment lineupEntryProps on LineupEntry {
  id
  type
  player {
    ...playerFields
  }
  substituted {
    ...playerFields
  }
  periodIn
  periodOut
  inSeconds
  outSeconds
  shirtNumber
  reason
  inEvent {
    id
    timestamp
    reason
    offscreen
  }
  outEvent {
    id
    timestamp
    reason
    offscreen
  }
  dataFrames {
    first
    last
  }
}
    ${PlayerFieldsFragmentDoc}`;
export const LabelTaskPropsFragmentDoc = gql`
    fragment labelTaskProps on TrackLabelTask {
  id
  start_frame
  end_frame
  start_x
  start_y
  start_z
  class_type
  owner {
    id
    firstname
    lastname
  }
  lineupentry {
    ...lineupEntryProps
  }
}
    ${LineupEntryPropsFragmentDoc}`;
export const SessionPropsFragmentDoc = gql`
    fragment sessionProps on Session {
  id
  name
  label
  addSecondsOffset
  location
  playedAt
  createdAt
  startedAt
  finishedAt
  account {
    id
  }
  labelAccount {
    id
  }
  lineup {
    ...lineupEntryProps
  }
  teamHome {
    id
    name
    keeperColor
    playerColor
  }
  teamAway {
    id
    name
    keeperColor
    playerColor
  }
  teamHomeKeeperColor
  teamHomePlayersColor
  teamAwayKeeperColor
  teamAwayPlayersColor
  refereeColor
  competition
  keepData
  fullID
  nrPlayers
  nrKeepers
  homeScore
  awayScore
  approved
  createdBy {
    id
  }
  pitch {
    id
    name
    field_length
    field_width
  }
  videos {
    videoInfo {
      url
      width
      height
      fps
      bitrate
      duration
      codec
      syncOffset
    }
    calibration
    clickPoints
    sortOrder
    url
    id
    transcodeStatus {
      streamUrl
      state
      error
    }
    ip
  }
  labelPositions {
    id
    videoTime
    classType
    x
    y
    z
  }
  labelTasks {
    ...labelTaskProps
  }
  pipeline {
    id
  }
  periods {
    id
    type
    label
    startTime
    endTime
    teamLeft {
      id
      name
    }
  }
  events {
    id
    timestamp
    type
    reason
    offscreen
    team {
      id
      name
    }
    in {
      id
      type
      number
    }
    out {
      id
      type
      number
    }
  }
  lastRun {
    id
    errorMessage
    runExportStatus
    saveRunStatus {
      percent_completed
    }
    exportStatus {
      progress
      state
      finish_state
    }
    status {
      state
    }
    session {
      addSecondsOffset
      periods {
        id
        startTime
        endTime
      }
      videos {
        videoInfo {
          fps
        }
      }
    }
  }
  matchInfoUrl
}
    ${LineupEntryPropsFragmentDoc}
${LabelTaskPropsFragmentDoc}`;
export const SettingsFragmentFragmentDoc = gql`
    fragment settingsFragment on Settings {
  id
  defaultPipeline {
    id
  }
  sessionsBucket
  frontendVersion
  apiVersion
}
    `;
export const TeamInfoFragmentDoc = gql`
    fragment teamInfo on Team {
  id
  name
  keeperColor
  playerColor
}
    `;
export const UserFragmentFragmentDoc = gql`
    fragment userFragment on User {
  id
  email
  firstname
  lastname
  account {
    id
  }
  accountEnabled
  accountLocked
  emailVerified
  roles {
    name
    privileges
  }
}
    `;
export const AccountsDocument = gql`
    query accounts($search: String, $types: [AccountType!]) {
  accounts(input: {search: $search, types: $types}) {
    accounts {
      ...accountFragment
    }
  }
}
    ${AccountFragmentFragmentDoc}`;

/**
 * __useAccountsQuery__
 *
 * To run a query within a React component, call `useAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useAccountsQuery(baseOptions?: Apollo.QueryHookOptions<AccountsQuery, AccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountsQuery, AccountsQueryVariables>(AccountsDocument, options);
      }
export function useAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountsQuery, AccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountsQuery, AccountsQueryVariables>(AccountsDocument, options);
        }
export type AccountsQueryHookResult = ReturnType<typeof useAccountsQuery>;
export type AccountsLazyQueryHookResult = ReturnType<typeof useAccountsLazyQuery>;
export type AccountsQueryResult = Apollo.QueryResult<AccountsQuery, AccountsQueryVariables>;
export const AccountDocument = gql`
    query account($id: ID!) {
  account(id: $id) {
    ...accountFragment
  }
}
    ${AccountFragmentFragmentDoc}`;

/**
 * __useAccountQuery__
 *
 * To run a query within a React component, call `useAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAccountQuery(baseOptions: Apollo.QueryHookOptions<AccountQuery, AccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountQuery, AccountQueryVariables>(AccountDocument, options);
      }
export function useAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountQuery, AccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountQuery, AccountQueryVariables>(AccountDocument, options);
        }
export type AccountQueryHookResult = ReturnType<typeof useAccountQuery>;
export type AccountLazyQueryHookResult = ReturnType<typeof useAccountLazyQuery>;
export type AccountQueryResult = Apollo.QueryResult<AccountQuery, AccountQueryVariables>;
export const AddAccountDocument = gql`
    mutation addAccount($id: ID!, $name: String!, $accountType: AccountType!) {
  addAccount(id: $id, name: $name, accountType: $accountType) {
    ...accountFragment
  }
}
    ${AccountFragmentFragmentDoc}`;

/**
 * __useAddAccountMutation__
 *
 * To run a mutation, you first call `useAddAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAccountMutation, { data, loading, error }] = useAddAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      accountType: // value for 'accountType'
 *   },
 * });
 */
export function useAddAccountMutation(baseOptions?: Apollo.MutationHookOptions<AddAccountMutation, AddAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAccountMutation, AddAccountMutationVariables>(AddAccountDocument, options);
      }
export type AddAccountMutationHookResult = ReturnType<typeof useAddAccountMutation>;
export type AddAccountMutationResult = Apollo.MutationResult<AddAccountMutation>;
export type AddAccountMutationOptions = Apollo.BaseMutationOptions<AddAccountMutation, AddAccountMutationVariables>;
export const UpdateAccountDocument = gql`
    mutation updateAccount($id: ID!, $name: String!) {
  updateAccount(id: $id, name: $name) {
    ...accountFragment
  }
}
    ${AccountFragmentFragmentDoc}`;

/**
 * __useUpdateAccountMutation__
 *
 * To run a mutation, you first call `useUpdateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountMutation, { data, loading, error }] = useUpdateAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountMutation, UpdateAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountMutation, UpdateAccountMutationVariables>(UpdateAccountDocument, options);
      }
export type UpdateAccountMutationHookResult = ReturnType<typeof useUpdateAccountMutation>;
export type UpdateAccountMutationResult = Apollo.MutationResult<UpdateAccountMutation>;
export type UpdateAccountMutationOptions = Apollo.BaseMutationOptions<UpdateAccountMutation, UpdateAccountMutationVariables>;
export const DeleteAccountDocument = gql`
    mutation deleteAccount($id: ID!) {
  deleteAccount(id: $id)
}
    `;

/**
 * __useDeleteAccountMutation__
 *
 * To run a mutation, you first call `useDeleteAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountMutation, { data, loading, error }] = useDeleteAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAccountMutation, DeleteAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAccountMutation, DeleteAccountMutationVariables>(DeleteAccountDocument, options);
      }
export type DeleteAccountMutationHookResult = ReturnType<typeof useDeleteAccountMutation>;
export type DeleteAccountMutationResult = Apollo.MutationResult<DeleteAccountMutation>;
export type DeleteAccountMutationOptions = Apollo.BaseMutationOptions<DeleteAccountMutation, DeleteAccountMutationVariables>;
export const AuditLogsDocument = gql`
    query auditLogs($pagination: Pagination, $sorting: [Sorting], $search: String, $from: Long, $until: Long, $user: ID, $session: ID, $types: [AuditLogType!]) {
  auditlogs(input: {pagination: $pagination, sorting: $sorting, search: $search, from: $from, until: $until, user: $user, session: $session, types: $types}) {
    logs {
      type
      timestamp
      params
      sessionid
      user {
        id
      }
    }
    count
  }
}
    `;

/**
 * __useAuditLogsQuery__
 *
 * To run a query within a React component, call `useAuditLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditLogsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sorting: // value for 'sorting'
 *      search: // value for 'search'
 *      from: // value for 'from'
 *      until: // value for 'until'
 *      user: // value for 'user'
 *      session: // value for 'session'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useAuditLogsQuery(baseOptions?: Apollo.QueryHookOptions<AuditLogsQuery, AuditLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuditLogsQuery, AuditLogsQueryVariables>(AuditLogsDocument, options);
      }
export function useAuditLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuditLogsQuery, AuditLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuditLogsQuery, AuditLogsQueryVariables>(AuditLogsDocument, options);
        }
export type AuditLogsQueryHookResult = ReturnType<typeof useAuditLogsQuery>;
export type AuditLogsLazyQueryHookResult = ReturnType<typeof useAuditLogsLazyQuery>;
export type AuditLogsQueryResult = Apollo.QueryResult<AuditLogsQuery, AuditLogsQueryVariables>;
export const PodsDocument = gql`
    query pods($namespace: String!, $deployment: String!) {
  pods(namespace: $namespace, deployment: $deployment)
}
    `;

/**
 * __usePodsQuery__
 *
 * To run a query within a React component, call `usePodsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePodsQuery({
 *   variables: {
 *      namespace: // value for 'namespace'
 *      deployment: // value for 'deployment'
 *   },
 * });
 */
export function usePodsQuery(baseOptions: Apollo.QueryHookOptions<PodsQuery, PodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PodsQuery, PodsQueryVariables>(PodsDocument, options);
      }
export function usePodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PodsQuery, PodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PodsQuery, PodsQueryVariables>(PodsDocument, options);
        }
export type PodsQueryHookResult = ReturnType<typeof usePodsQuery>;
export type PodsLazyQueryHookResult = ReturnType<typeof usePodsLazyQuery>;
export type PodsQueryResult = Apollo.QueryResult<PodsQuery, PodsQueryVariables>;
export const AllpipelinecomponentsDocument = gql`
    query allpipelinecomponents {
  pipelinecomponents {
    name
    version
    image
    id
    cpurequest
    memrequest
    gpurequest
    config_blob
    files
    ports
    inputs
    outputs
    replicas
    per_camera
    cpulimit
    memlimit
    postprocessing
    pipelines {
      id
    }
  }
}
    `;

/**
 * __useAllpipelinecomponentsQuery__
 *
 * To run a query within a React component, call `useAllpipelinecomponentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllpipelinecomponentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllpipelinecomponentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllpipelinecomponentsQuery(baseOptions?: Apollo.QueryHookOptions<AllpipelinecomponentsQuery, AllpipelinecomponentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllpipelinecomponentsQuery, AllpipelinecomponentsQueryVariables>(AllpipelinecomponentsDocument, options);
      }
export function useAllpipelinecomponentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllpipelinecomponentsQuery, AllpipelinecomponentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllpipelinecomponentsQuery, AllpipelinecomponentsQueryVariables>(AllpipelinecomponentsDocument, options);
        }
export type AllpipelinecomponentsQueryHookResult = ReturnType<typeof useAllpipelinecomponentsQuery>;
export type AllpipelinecomponentsLazyQueryHookResult = ReturnType<typeof useAllpipelinecomponentsLazyQuery>;
export type AllpipelinecomponentsQueryResult = Apollo.QueryResult<AllpipelinecomponentsQuery, AllpipelinecomponentsQueryVariables>;
export const AddPipelineComponentDocument = gql`
    mutation addPipelineComponent($name: String!, $version: String!, $image: String!, $cpulimit: String!, $cpurequest: String!, $memlimit: String!, $memrequest: String!, $gpurequest: Int!, $replicas: Int!, $files: [String!], $inputs: [String!], $outputs: [String!], $config_blob: String, $postprocessing: Boolean!, $ports: [Int!], $per_camera: Boolean) {
  addPipelineComponent(input: {name: $name, version: $version, image: $image, cpulimit: $cpulimit, cpurequest: $cpurequest, memlimit: $memlimit, memrequest: $memrequest, gpurequest: $gpurequest, replicas: $replicas, per_camera: $per_camera, files: $files, inputs: $inputs, outputs: $outputs, config_blob: $config_blob, postprocessing: $postprocessing, ports: $ports}) {
    name
    version
    image
    id
    cpurequest
    memrequest
    gpurequest
    config_blob
    files
    ports
    inputs
    outputs
    replicas
    per_camera
    cpulimit
    memlimit
    postprocessing
  }
}
    `;

/**
 * __useAddPipelineComponentMutation__
 *
 * To run a mutation, you first call `useAddPipelineComponentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPipelineComponentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPipelineComponentMutation, { data, loading, error }] = useAddPipelineComponentMutation({
 *   variables: {
 *      name: // value for 'name'
 *      version: // value for 'version'
 *      image: // value for 'image'
 *      cpulimit: // value for 'cpulimit'
 *      cpurequest: // value for 'cpurequest'
 *      memlimit: // value for 'memlimit'
 *      memrequest: // value for 'memrequest'
 *      gpurequest: // value for 'gpurequest'
 *      replicas: // value for 'replicas'
 *      files: // value for 'files'
 *      inputs: // value for 'inputs'
 *      outputs: // value for 'outputs'
 *      config_blob: // value for 'config_blob'
 *      postprocessing: // value for 'postprocessing'
 *      ports: // value for 'ports'
 *      per_camera: // value for 'per_camera'
 *   },
 * });
 */
export function useAddPipelineComponentMutation(baseOptions?: Apollo.MutationHookOptions<AddPipelineComponentMutation, AddPipelineComponentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPipelineComponentMutation, AddPipelineComponentMutationVariables>(AddPipelineComponentDocument, options);
      }
export type AddPipelineComponentMutationHookResult = ReturnType<typeof useAddPipelineComponentMutation>;
export type AddPipelineComponentMutationResult = Apollo.MutationResult<AddPipelineComponentMutation>;
export type AddPipelineComponentMutationOptions = Apollo.BaseMutationOptions<AddPipelineComponentMutation, AddPipelineComponentMutationVariables>;
export const UpdatePipelineComponentDocument = gql`
    mutation updatePipelineComponent($id: ID!, $name: String!, $version: String!, $image: String!, $cpulimit: String!, $cpurequest: String!, $memlimit: String!, $memrequest: String!, $gpurequest: Int!, $replicas: Int!, $per_camera: Boolean, $files: [String!], $inputs: [String!], $outputs: [String!], $config_blob: String, $postprocessing: Boolean!, $ports: [Int!]) {
  updatePipelineComponent(id: $id, update: {name: $name, version: $version, image: $image, cpulimit: $cpulimit, cpurequest: $cpurequest, memlimit: $memlimit, memrequest: $memrequest, gpurequest: $gpurequest, replicas: $replicas, per_camera: $per_camera, files: $files, inputs: $inputs, outputs: $outputs, config_blob: $config_blob, postprocessing: $postprocessing, ports: $ports}) {
    name
    version
    image
    id
    cpurequest
    memrequest
    gpurequest
    config_blob
    files
    ports
    inputs
    outputs
    replicas
    per_camera
    cpulimit
    memlimit
    postprocessing
  }
}
    `;

/**
 * __useUpdatePipelineComponentMutation__
 *
 * To run a mutation, you first call `useUpdatePipelineComponentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePipelineComponentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePipelineComponentMutation, { data, loading, error }] = useUpdatePipelineComponentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      version: // value for 'version'
 *      image: // value for 'image'
 *      cpulimit: // value for 'cpulimit'
 *      cpurequest: // value for 'cpurequest'
 *      memlimit: // value for 'memlimit'
 *      memrequest: // value for 'memrequest'
 *      gpurequest: // value for 'gpurequest'
 *      replicas: // value for 'replicas'
 *      per_camera: // value for 'per_camera'
 *      files: // value for 'files'
 *      inputs: // value for 'inputs'
 *      outputs: // value for 'outputs'
 *      config_blob: // value for 'config_blob'
 *      postprocessing: // value for 'postprocessing'
 *      ports: // value for 'ports'
 *   },
 * });
 */
export function useUpdatePipelineComponentMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePipelineComponentMutation, UpdatePipelineComponentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePipelineComponentMutation, UpdatePipelineComponentMutationVariables>(UpdatePipelineComponentDocument, options);
      }
export type UpdatePipelineComponentMutationHookResult = ReturnType<typeof useUpdatePipelineComponentMutation>;
export type UpdatePipelineComponentMutationResult = Apollo.MutationResult<UpdatePipelineComponentMutation>;
export type UpdatePipelineComponentMutationOptions = Apollo.BaseMutationOptions<UpdatePipelineComponentMutation, UpdatePipelineComponentMutationVariables>;
export const DeletePipelineComponentDocument = gql`
    mutation deletePipelineComponent($id: ID!) {
  deletePipelineComponent(id: $id)
}
    `;

/**
 * __useDeletePipelineComponentMutation__
 *
 * To run a mutation, you first call `useDeletePipelineComponentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePipelineComponentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePipelineComponentMutation, { data, loading, error }] = useDeletePipelineComponentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePipelineComponentMutation(baseOptions?: Apollo.MutationHookOptions<DeletePipelineComponentMutation, DeletePipelineComponentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePipelineComponentMutation, DeletePipelineComponentMutationVariables>(DeletePipelineComponentDocument, options);
      }
export type DeletePipelineComponentMutationHookResult = ReturnType<typeof useDeletePipelineComponentMutation>;
export type DeletePipelineComponentMutationResult = Apollo.MutationResult<DeletePipelineComponentMutation>;
export type DeletePipelineComponentMutationOptions = Apollo.BaseMutationOptions<DeletePipelineComponentMutation, DeletePipelineComponentMutationVariables>;
export const PipelinesDocument = gql`
    query pipelines {
  allpipelines {
    id
    name
    version
    created
    type
  }
}
    `;

/**
 * __usePipelinesQuery__
 *
 * To run a query within a React component, call `usePipelinesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePipelinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePipelinesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePipelinesQuery(baseOptions?: Apollo.QueryHookOptions<PipelinesQuery, PipelinesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PipelinesQuery, PipelinesQueryVariables>(PipelinesDocument, options);
      }
export function usePipelinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PipelinesQuery, PipelinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PipelinesQuery, PipelinesQueryVariables>(PipelinesDocument, options);
        }
export type PipelinesQueryHookResult = ReturnType<typeof usePipelinesQuery>;
export type PipelinesLazyQueryHookResult = ReturnType<typeof usePipelinesLazyQuery>;
export type PipelinesQueryResult = Apollo.QueryResult<PipelinesQuery, PipelinesQueryVariables>;
export const PipelineOverviewDocument = gql`
    query pipelineOverview($pagination: Pagination, $sorting: [Sorting], $versions: [String], $search: String, $types: [PipelineType], $components: [ID], $creationStart: Long, $creationEnd: Long, $lastRunStart: Long, $lastRunEnd: Long) {
  pipelines(input: {pagination: $pagination, sorting: $sorting, versions: $versions, search: $search, types: $types, components: $components, creationStart: $creationStart, creationEnd: $creationEnd, lastRunStart: $lastRunStart, lastRunEnd: $lastRunEnd}) {
    pipelines {
      ...pipelineFragment
    }
    count
  }
}
    ${PipelineFragmentFragmentDoc}`;

/**
 * __usePipelineOverviewQuery__
 *
 * To run a query within a React component, call `usePipelineOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePipelineOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePipelineOverviewQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sorting: // value for 'sorting'
 *      versions: // value for 'versions'
 *      search: // value for 'search'
 *      types: // value for 'types'
 *      components: // value for 'components'
 *      creationStart: // value for 'creationStart'
 *      creationEnd: // value for 'creationEnd'
 *      lastRunStart: // value for 'lastRunStart'
 *      lastRunEnd: // value for 'lastRunEnd'
 *   },
 * });
 */
export function usePipelineOverviewQuery(baseOptions?: Apollo.QueryHookOptions<PipelineOverviewQuery, PipelineOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PipelineOverviewQuery, PipelineOverviewQueryVariables>(PipelineOverviewDocument, options);
      }
export function usePipelineOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PipelineOverviewQuery, PipelineOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PipelineOverviewQuery, PipelineOverviewQueryVariables>(PipelineOverviewDocument, options);
        }
export type PipelineOverviewQueryHookResult = ReturnType<typeof usePipelineOverviewQuery>;
export type PipelineOverviewLazyQueryHookResult = ReturnType<typeof usePipelineOverviewLazyQuery>;
export type PipelineOverviewQueryResult = Apollo.QueryResult<PipelineOverviewQuery, PipelineOverviewQueryVariables>;
export const PipelineDocument = gql`
    query pipeline($pipeline: ID!) {
  pipeline(id: $pipeline) {
    id
    name
    created
    type
    pipelineComponentSettings {
      pipelineComponent {
        id
        name
      }
      inputmap {
        in
        topic
      }
      outputmap {
        in
        topic
      }
    }
    createdBy {
      email
    }
    version
    runs {
      id
      status {
        state
      }
    }
    pipelinecomponents {
      id
      name
      version
      inputs
      outputs
      ports
      config_blob
    }
    topics {
      partitions
      replication_factor
      per_camera
      topic
      compress
    }
  }
}
    `;

/**
 * __usePipelineQuery__
 *
 * To run a query within a React component, call `usePipelineQuery` and pass it any options that fit your needs.
 * When your component renders, `usePipelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePipelineQuery({
 *   variables: {
 *      pipeline: // value for 'pipeline'
 *   },
 * });
 */
export function usePipelineQuery(baseOptions: Apollo.QueryHookOptions<PipelineQuery, PipelineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PipelineQuery, PipelineQueryVariables>(PipelineDocument, options);
      }
export function usePipelineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PipelineQuery, PipelineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PipelineQuery, PipelineQueryVariables>(PipelineDocument, options);
        }
export type PipelineQueryHookResult = ReturnType<typeof usePipelineQuery>;
export type PipelineLazyQueryHookResult = ReturnType<typeof usePipelineLazyQuery>;
export type PipelineQueryResult = Apollo.QueryResult<PipelineQuery, PipelineQueryVariables>;
export const PipelinecomponentsDocument = gql`
    query pipelinecomponents {
  pipelinecomponents {
    id
    name
    image
    version
    cpurequest
    memrequest
    replicas
    per_camera
    files
    ports
    inputs
    outputs
    config_blob
  }
}
    `;

/**
 * __usePipelinecomponentsQuery__
 *
 * To run a query within a React component, call `usePipelinecomponentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePipelinecomponentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePipelinecomponentsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePipelinecomponentsQuery(baseOptions?: Apollo.QueryHookOptions<PipelinecomponentsQuery, PipelinecomponentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PipelinecomponentsQuery, PipelinecomponentsQueryVariables>(PipelinecomponentsDocument, options);
      }
export function usePipelinecomponentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PipelinecomponentsQuery, PipelinecomponentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PipelinecomponentsQuery, PipelinecomponentsQueryVariables>(PipelinecomponentsDocument, options);
        }
export type PipelinecomponentsQueryHookResult = ReturnType<typeof usePipelinecomponentsQuery>;
export type PipelinecomponentsLazyQueryHookResult = ReturnType<typeof usePipelinecomponentsLazyQuery>;
export type PipelinecomponentsQueryResult = Apollo.QueryResult<PipelinecomponentsQuery, PipelinecomponentsQueryVariables>;
export const PipelinecomponentDocument = gql`
    query pipelinecomponent($pipelinecomponentid: ID!) {
  pipelinecomponent(id: $pipelinecomponentid) {
    name
    version
    image
    id
    cpurequest
    memrequest
    gpurequest
    config_blob
    files
    ports
    inputs
    outputs
    replicas
    per_camera
    cpulimit
    memlimit
    postprocessing
    pipelines {
      id
      runs {
        id
        status {
          state
        }
      }
    }
  }
}
    `;

/**
 * __usePipelinecomponentQuery__
 *
 * To run a query within a React component, call `usePipelinecomponentQuery` and pass it any options that fit your needs.
 * When your component renders, `usePipelinecomponentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePipelinecomponentQuery({
 *   variables: {
 *      pipelinecomponentid: // value for 'pipelinecomponentid'
 *   },
 * });
 */
export function usePipelinecomponentQuery(baseOptions: Apollo.QueryHookOptions<PipelinecomponentQuery, PipelinecomponentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PipelinecomponentQuery, PipelinecomponentQueryVariables>(PipelinecomponentDocument, options);
      }
export function usePipelinecomponentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PipelinecomponentQuery, PipelinecomponentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PipelinecomponentQuery, PipelinecomponentQueryVariables>(PipelinecomponentDocument, options);
        }
export type PipelinecomponentQueryHookResult = ReturnType<typeof usePipelinecomponentQuery>;
export type PipelinecomponentLazyQueryHookResult = ReturnType<typeof usePipelinecomponentLazyQuery>;
export type PipelinecomponentQueryResult = Apollo.QueryResult<PipelinecomponentQuery, PipelinecomponentQueryVariables>;
export const AddPipelineDocument = gql`
    mutation addPipeline($name: String!, $version: String!, $type: PipelineType!, $componentsettings: [ComponentSettingsInput!], $pipelinecomponents: [ID!], $topics: [PipelineTopicInput!]) {
  addPipeline(input: {name: $name, version: $version, type: $type, componentsettings: $componentsettings, pipelinecomponents: $pipelinecomponents, topics: $topics}) {
    ...pipelineFragment
  }
}
    ${PipelineFragmentFragmentDoc}`;

/**
 * __useAddPipelineMutation__
 *
 * To run a mutation, you first call `useAddPipelineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPipelineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPipelineMutation, { data, loading, error }] = useAddPipelineMutation({
 *   variables: {
 *      name: // value for 'name'
 *      version: // value for 'version'
 *      type: // value for 'type'
 *      componentsettings: // value for 'componentsettings'
 *      pipelinecomponents: // value for 'pipelinecomponents'
 *      topics: // value for 'topics'
 *   },
 * });
 */
export function useAddPipelineMutation(baseOptions?: Apollo.MutationHookOptions<AddPipelineMutation, AddPipelineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPipelineMutation, AddPipelineMutationVariables>(AddPipelineDocument, options);
      }
export type AddPipelineMutationHookResult = ReturnType<typeof useAddPipelineMutation>;
export type AddPipelineMutationResult = Apollo.MutationResult<AddPipelineMutation>;
export type AddPipelineMutationOptions = Apollo.BaseMutationOptions<AddPipelineMutation, AddPipelineMutationVariables>;
export const UpdatePipelineDocument = gql`
    mutation updatePipeline($id: ID!, $name: String!, $version: String!, $type: PipelineType!, $componentsettings: [ComponentSettingsInput!], $pipelinecomponents: [ID!], $topics: [PipelineTopicInput!]) {
  updatePipeline(id: $id, update: {name: $name, version: $version, type: $type, componentsettings: $componentsettings, pipelinecomponents: $pipelinecomponents, topics: $topics}) {
    ...pipelineFragment
  }
}
    ${PipelineFragmentFragmentDoc}`;

/**
 * __useUpdatePipelineMutation__
 *
 * To run a mutation, you first call `useUpdatePipelineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePipelineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePipelineMutation, { data, loading, error }] = useUpdatePipelineMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      version: // value for 'version'
 *      type: // value for 'type'
 *      componentsettings: // value for 'componentsettings'
 *      pipelinecomponents: // value for 'pipelinecomponents'
 *      topics: // value for 'topics'
 *   },
 * });
 */
export function useUpdatePipelineMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePipelineMutation, UpdatePipelineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePipelineMutation, UpdatePipelineMutationVariables>(UpdatePipelineDocument, options);
      }
export type UpdatePipelineMutationHookResult = ReturnType<typeof useUpdatePipelineMutation>;
export type UpdatePipelineMutationResult = Apollo.MutationResult<UpdatePipelineMutation>;
export type UpdatePipelineMutationOptions = Apollo.BaseMutationOptions<UpdatePipelineMutation, UpdatePipelineMutationVariables>;
export const DeletePipelineDocument = gql`
    mutation deletePipeline($id: ID!) {
  deletePipeline(id: $id) {
    result
  }
}
    `;

/**
 * __useDeletePipelineMutation__
 *
 * To run a mutation, you first call `useDeletePipelineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePipelineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePipelineMutation, { data, loading, error }] = useDeletePipelineMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePipelineMutation(baseOptions?: Apollo.MutationHookOptions<DeletePipelineMutation, DeletePipelineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePipelineMutation, DeletePipelineMutationVariables>(DeletePipelineDocument, options);
      }
export type DeletePipelineMutationHookResult = ReturnType<typeof useDeletePipelineMutation>;
export type DeletePipelineMutationResult = Apollo.MutationResult<DeletePipelineMutation>;
export type DeletePipelineMutationOptions = Apollo.BaseMutationOptions<DeletePipelineMutation, DeletePipelineMutationVariables>;
export const PitchesDocument = gql`
    query pitches {
  pitches {
    ...pitchFragment
  }
}
    ${PitchFragmentFragmentDoc}`;

/**
 * __usePitchesQuery__
 *
 * To run a query within a React component, call `usePitchesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePitchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePitchesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePitchesQuery(baseOptions?: Apollo.QueryHookOptions<PitchesQuery, PitchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PitchesQuery, PitchesQueryVariables>(PitchesDocument, options);
      }
export function usePitchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PitchesQuery, PitchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PitchesQuery, PitchesQueryVariables>(PitchesDocument, options);
        }
export type PitchesQueryHookResult = ReturnType<typeof usePitchesQuery>;
export type PitchesLazyQueryHookResult = ReturnType<typeof usePitchesLazyQuery>;
export type PitchesQueryResult = Apollo.QueryResult<PitchesQuery, PitchesQueryVariables>;
export const PitchDocument = gql`
    query pitch($id: ID!) {
  pitch(id: $id) {
    ...pitchFragment
  }
}
    ${PitchFragmentFragmentDoc}`;

/**
 * __usePitchQuery__
 *
 * To run a query within a React component, call `usePitchQuery` and pass it any options that fit your needs.
 * When your component renders, `usePitchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePitchQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePitchQuery(baseOptions: Apollo.QueryHookOptions<PitchQuery, PitchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PitchQuery, PitchQueryVariables>(PitchDocument, options);
      }
export function usePitchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PitchQuery, PitchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PitchQuery, PitchQueryVariables>(PitchDocument, options);
        }
export type PitchQueryHookResult = ReturnType<typeof usePitchQuery>;
export type PitchLazyQueryHookResult = ReturnType<typeof usePitchLazyQuery>;
export type PitchQueryResult = Apollo.QueryResult<PitchQuery, PitchQueryVariables>;
export const AddPitchDocument = gql`
    mutation addPitch($name: String!, $pitchType: String, $field_length: Int!, $field_width: Int!, $lat: Float!, $lng: Float!) {
  addPitch(input: {name: $name, field_length: $field_length, field_width: $field_width, lat: $lat, lng: $lng, pitchType: $pitchType}) {
    ...pitchFragment
  }
}
    ${PitchFragmentFragmentDoc}`;

/**
 * __useAddPitchMutation__
 *
 * To run a mutation, you first call `useAddPitchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPitchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPitchMutation, { data, loading, error }] = useAddPitchMutation({
 *   variables: {
 *      name: // value for 'name'
 *      pitchType: // value for 'pitchType'
 *      field_length: // value for 'field_length'
 *      field_width: // value for 'field_width'
 *      lat: // value for 'lat'
 *      lng: // value for 'lng'
 *   },
 * });
 */
export function useAddPitchMutation(baseOptions?: Apollo.MutationHookOptions<AddPitchMutation, AddPitchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPitchMutation, AddPitchMutationVariables>(AddPitchDocument, options);
      }
export type AddPitchMutationHookResult = ReturnType<typeof useAddPitchMutation>;
export type AddPitchMutationResult = Apollo.MutationResult<AddPitchMutation>;
export type AddPitchMutationOptions = Apollo.BaseMutationOptions<AddPitchMutation, AddPitchMutationVariables>;
export const DeletePitchDocument = gql`
    mutation deletePitch($id: ID!) {
  deletePitch(id: $id) {
    result
  }
}
    `;

/**
 * __useDeletePitchMutation__
 *
 * To run a mutation, you first call `useDeletePitchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePitchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePitchMutation, { data, loading, error }] = useDeletePitchMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePitchMutation(baseOptions?: Apollo.MutationHookOptions<DeletePitchMutation, DeletePitchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePitchMutation, DeletePitchMutationVariables>(DeletePitchDocument, options);
      }
export type DeletePitchMutationHookResult = ReturnType<typeof useDeletePitchMutation>;
export type DeletePitchMutationResult = Apollo.MutationResult<DeletePitchMutation>;
export type DeletePitchMutationOptions = Apollo.BaseMutationOptions<DeletePitchMutation, DeletePitchMutationVariables>;
export const UpdatePitchDocument = gql`
    mutation updatePitch($id: ID!, $name: String!, $field_length: Int!, $field_width: Int!, $lat: Float!, $lng: Float!, $pitchType: String) {
  updatePitch(id: $id, input: {name: $name, field_length: $field_length, field_width: $field_width, lat: $lat, lng: $lng, pitchType: $pitchType}) {
    ...pitchFragment
  }
}
    ${PitchFragmentFragmentDoc}`;

/**
 * __useUpdatePitchMutation__
 *
 * To run a mutation, you first call `useUpdatePitchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePitchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePitchMutation, { data, loading, error }] = useUpdatePitchMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      field_length: // value for 'field_length'
 *      field_width: // value for 'field_width'
 *      lat: // value for 'lat'
 *      lng: // value for 'lng'
 *      pitchType: // value for 'pitchType'
 *   },
 * });
 */
export function useUpdatePitchMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePitchMutation, UpdatePitchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePitchMutation, UpdatePitchMutationVariables>(UpdatePitchDocument, options);
      }
export type UpdatePitchMutationHookResult = ReturnType<typeof useUpdatePitchMutation>;
export type UpdatePitchMutationResult = Apollo.MutationResult<UpdatePitchMutation>;
export type UpdatePitchMutationOptions = Apollo.BaseMutationOptions<UpdatePitchMutation, UpdatePitchMutationVariables>;
export const PlayersDocument = gql`
    query players($team: ID, $search: String) {
  players(team: $team, search: $search) {
    ...playerInfo
  }
}
    ${PlayerInfoFragmentDoc}`;

/**
 * __usePlayersQuery__
 *
 * To run a query within a React component, call `usePlayersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayersQuery({
 *   variables: {
 *      team: // value for 'team'
 *      search: // value for 'search'
 *   },
 * });
 */
export function usePlayersQuery(baseOptions?: Apollo.QueryHookOptions<PlayersQuery, PlayersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlayersQuery, PlayersQueryVariables>(PlayersDocument, options);
      }
export function usePlayersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlayersQuery, PlayersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlayersQuery, PlayersQueryVariables>(PlayersDocument, options);
        }
export type PlayersQueryHookResult = ReturnType<typeof usePlayersQuery>;
export type PlayersLazyQueryHookResult = ReturnType<typeof usePlayersLazyQuery>;
export type PlayersQueryResult = Apollo.QueryResult<PlayersQuery, PlayersQueryVariables>;
export const AddPlayerDocument = gql`
    mutation addPlayer($input: AddPlayerInput!) {
  addPlayer(input: $input) {
    ...playerInfo
  }
}
    ${PlayerInfoFragmentDoc}`;

/**
 * __useAddPlayerMutation__
 *
 * To run a mutation, you first call `useAddPlayerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPlayerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPlayerMutation, { data, loading, error }] = useAddPlayerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPlayerMutation(baseOptions?: Apollo.MutationHookOptions<AddPlayerMutation, AddPlayerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPlayerMutation, AddPlayerMutationVariables>(AddPlayerDocument, options);
      }
export type AddPlayerMutationHookResult = ReturnType<typeof useAddPlayerMutation>;
export type AddPlayerMutationResult = Apollo.MutationResult<AddPlayerMutation>;
export type AddPlayerMutationOptions = Apollo.BaseMutationOptions<AddPlayerMutation, AddPlayerMutationVariables>;
export const RunsDocument = gql`
    query runs($pagination: Pagination, $sorting: [Sorting], $search: String, $statuses: [RunState!], $creationStart: Long, $creationEnd: Long, $runStart: Long, $runEnd: Long, $completedOnly: Boolean, $pipelines: [ID], $pitches: [ID]) {
  runs(input: {pagination: $pagination, sorting: $sorting, search: $search, statuses: $statuses, creationStart: $creationStart, creationEnd: $creationEnd, runStart: $runStart, runEnd: $runEnd, completedOnly: $completedOnly, pipelines: $pipelines, pitches: $pitches}) {
    runs {
      ...runFields
    }
    count
  }
}
    ${RunFieldsFragmentDoc}`;

/**
 * __useRunsQuery__
 *
 * To run a query within a React component, call `useRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sorting: // value for 'sorting'
 *      search: // value for 'search'
 *      statuses: // value for 'statuses'
 *      creationStart: // value for 'creationStart'
 *      creationEnd: // value for 'creationEnd'
 *      runStart: // value for 'runStart'
 *      runEnd: // value for 'runEnd'
 *      completedOnly: // value for 'completedOnly'
 *      pipelines: // value for 'pipelines'
 *      pitches: // value for 'pitches'
 *   },
 * });
 */
export function useRunsQuery(baseOptions?: Apollo.QueryHookOptions<RunsQuery, RunsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RunsQuery, RunsQueryVariables>(RunsDocument, options);
      }
export function useRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RunsQuery, RunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RunsQuery, RunsQueryVariables>(RunsDocument, options);
        }
export type RunsQueryHookResult = ReturnType<typeof useRunsQuery>;
export type RunsLazyQueryHookResult = ReturnType<typeof useRunsLazyQuery>;
export type RunsQueryResult = Apollo.QueryResult<RunsQuery, RunsQueryVariables>;
export const RunDocument = gql`
    query run($id: ID) {
  run(id: $id) {
    ...runFields
  }
}
    ${RunFieldsFragmentDoc}`;

/**
 * __useRunQuery__
 *
 * To run a query within a React component, call `useRunQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRunQuery(baseOptions?: Apollo.QueryHookOptions<RunQuery, RunQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RunQuery, RunQueryVariables>(RunDocument, options);
      }
export function useRunLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RunQuery, RunQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RunQuery, RunQueryVariables>(RunDocument, options);
        }
export type RunQueryHookResult = ReturnType<typeof useRunQuery>;
export type RunLazyQueryHookResult = ReturnType<typeof useRunLazyQuery>;
export type RunQueryResult = Apollo.QueryResult<RunQuery, RunQueryVariables>;
export const AddRunDocument = gql`
    mutation addRun($id: ID!, $kafka: String, $startTime: Int!, $session: ID, $pipeline: ID, $inputs: [InputInput], $pipelineSettings: [PipelineSettingInput!]) {
  addRun(input: {id: $id, kafka: $kafka, startTime: $startTime, session: $session, pipeline: $pipeline, inputs: $inputs, pipelineSettings: $pipelineSettings}) {
    ...runFields
  }
}
    ${RunFieldsFragmentDoc}`;

/**
 * __useAddRunMutation__
 *
 * To run a mutation, you first call `useAddRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRunMutation, { data, loading, error }] = useAddRunMutation({
 *   variables: {
 *      id: // value for 'id'
 *      kafka: // value for 'kafka'
 *      startTime: // value for 'startTime'
 *      session: // value for 'session'
 *      pipeline: // value for 'pipeline'
 *      inputs: // value for 'inputs'
 *      pipelineSettings: // value for 'pipelineSettings'
 *   },
 * });
 */
export function useAddRunMutation(baseOptions?: Apollo.MutationHookOptions<AddRunMutation, AddRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddRunMutation, AddRunMutationVariables>(AddRunDocument, options);
      }
export type AddRunMutationHookResult = ReturnType<typeof useAddRunMutation>;
export type AddRunMutationResult = Apollo.MutationResult<AddRunMutation>;
export type AddRunMutationOptions = Apollo.BaseMutationOptions<AddRunMutation, AddRunMutationVariables>;
export const UpdateRunDocument = gql`
    mutation updateRun($id: ID!, $kafka: String, $startTime: Int!, $session: ID, $pipeline: ID, $inputs: [InputInput], $pipelineSettings: [PipelineSettingInput!]) {
  updateRun(id: $id, input: {id: $id, kafka: $kafka, startTime: $startTime, session: $session, pipeline: $pipeline, inputs: $inputs, pipelineSettings: $pipelineSettings}) {
    ...runFields
  }
}
    ${RunFieldsFragmentDoc}`;

/**
 * __useUpdateRunMutation__
 *
 * To run a mutation, you first call `useUpdateRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRunMutation, { data, loading, error }] = useUpdateRunMutation({
 *   variables: {
 *      id: // value for 'id'
 *      kafka: // value for 'kafka'
 *      startTime: // value for 'startTime'
 *      session: // value for 'session'
 *      pipeline: // value for 'pipeline'
 *      inputs: // value for 'inputs'
 *      pipelineSettings: // value for 'pipelineSettings'
 *   },
 * });
 */
export function useUpdateRunMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRunMutation, UpdateRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRunMutation, UpdateRunMutationVariables>(UpdateRunDocument, options);
      }
export type UpdateRunMutationHookResult = ReturnType<typeof useUpdateRunMutation>;
export type UpdateRunMutationResult = Apollo.MutationResult<UpdateRunMutation>;
export type UpdateRunMutationOptions = Apollo.BaseMutationOptions<UpdateRunMutation, UpdateRunMutationVariables>;
export const StartrunDocument = gql`
    mutation startrun($runid: ID) {
  startRun(id: $runid) {
    id
    status {
      state
    }
  }
}
    `;

/**
 * __useStartrunMutation__
 *
 * To run a mutation, you first call `useStartrunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartrunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startrunMutation, { data, loading, error }] = useStartrunMutation({
 *   variables: {
 *      runid: // value for 'runid'
 *   },
 * });
 */
export function useStartrunMutation(baseOptions?: Apollo.MutationHookOptions<StartrunMutation, StartrunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartrunMutation, StartrunMutationVariables>(StartrunDocument, options);
      }
export type StartrunMutationHookResult = ReturnType<typeof useStartrunMutation>;
export type StartrunMutationResult = Apollo.MutationResult<StartrunMutation>;
export type StartrunMutationOptions = Apollo.BaseMutationOptions<StartrunMutation, StartrunMutationVariables>;
export const DeleteDataDocument = gql`
    mutation deleteData($runid: ID) {
  deleteData(id: $runid) {
    runid
  }
}
    `;

/**
 * __useDeleteDataMutation__
 *
 * To run a mutation, you first call `useDeleteDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDataMutation, { data, loading, error }] = useDeleteDataMutation({
 *   variables: {
 *      runid: // value for 'runid'
 *   },
 * });
 */
export function useDeleteDataMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDataMutation, DeleteDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDataMutation, DeleteDataMutationVariables>(DeleteDataDocument, options);
      }
export type DeleteDataMutationHookResult = ReturnType<typeof useDeleteDataMutation>;
export type DeleteDataMutationResult = Apollo.MutationResult<DeleteDataMutation>;
export type DeleteDataMutationOptions = Apollo.BaseMutationOptions<DeleteDataMutation, DeleteDataMutationVariables>;
export const StoprunDocument = gql`
    mutation stoprun($runid: ID) {
  stopRun(id: $runid) {
    status {
      state
    }
  }
}
    `;

/**
 * __useStoprunMutation__
 *
 * To run a mutation, you first call `useStoprunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoprunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stoprunMutation, { data, loading, error }] = useStoprunMutation({
 *   variables: {
 *      runid: // value for 'runid'
 *   },
 * });
 */
export function useStoprunMutation(baseOptions?: Apollo.MutationHookOptions<StoprunMutation, StoprunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StoprunMutation, StoprunMutationVariables>(StoprunDocument, options);
      }
export type StoprunMutationHookResult = ReturnType<typeof useStoprunMutation>;
export type StoprunMutationResult = Apollo.MutationResult<StoprunMutation>;
export type StoprunMutationOptions = Apollo.BaseMutationOptions<StoprunMutation, StoprunMutationVariables>;
export const DeleterunDocument = gql`
    mutation deleterun($runid: ID) {
  deleteRun(id: $runid)
}
    `;

/**
 * __useDeleterunMutation__
 *
 * To run a mutation, you first call `useDeleterunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleterunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleterunMutation, { data, loading, error }] = useDeleterunMutation({
 *   variables: {
 *      runid: // value for 'runid'
 *   },
 * });
 */
export function useDeleterunMutation(baseOptions?: Apollo.MutationHookOptions<DeleterunMutation, DeleterunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleterunMutation, DeleterunMutationVariables>(DeleterunDocument, options);
      }
export type DeleterunMutationHookResult = ReturnType<typeof useDeleterunMutation>;
export type DeleterunMutationResult = Apollo.MutationResult<DeleterunMutation>;
export type DeleterunMutationOptions = Apollo.BaseMutationOptions<DeleterunMutation, DeleterunMutationVariables>;
export const ResetRunDocument = gql`
    mutation resetRun($runid: ID) {
  resetRun(id: $runid)
}
    `;

/**
 * __useResetRunMutation__
 *
 * To run a mutation, you first call `useResetRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetRunMutation, { data, loading, error }] = useResetRunMutation({
 *   variables: {
 *      runid: // value for 'runid'
 *   },
 * });
 */
export function useResetRunMutation(baseOptions?: Apollo.MutationHookOptions<ResetRunMutation, ResetRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetRunMutation, ResetRunMutationVariables>(ResetRunDocument, options);
      }
export type ResetRunMutationHookResult = ReturnType<typeof useResetRunMutation>;
export type ResetRunMutationResult = Apollo.MutationResult<ResetRunMutation>;
export type ResetRunMutationOptions = Apollo.BaseMutationOptions<ResetRunMutation, ResetRunMutationVariables>;
export const RunStatusDocument = gql`
    query runStatus($runid: ID!) {
  runStatus(id: $runid) {
    runid
  }
}
    `;

/**
 * __useRunStatusQuery__
 *
 * To run a query within a React component, call `useRunStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunStatusQuery({
 *   variables: {
 *      runid: // value for 'runid'
 *   },
 * });
 */
export function useRunStatusQuery(baseOptions: Apollo.QueryHookOptions<RunStatusQuery, RunStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RunStatusQuery, RunStatusQueryVariables>(RunStatusDocument, options);
      }
export function useRunStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RunStatusQuery, RunStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RunStatusQuery, RunStatusQueryVariables>(RunStatusDocument, options);
        }
export type RunStatusQueryHookResult = ReturnType<typeof useRunStatusQuery>;
export type RunStatusLazyQueryHookResult = ReturnType<typeof useRunStatusLazyQuery>;
export type RunStatusQueryResult = Apollo.QueryResult<RunStatusQuery, RunStatusQueryVariables>;
export const ComponentStatusDocument = gql`
    query componentStatus($runid: String!, $component: String!) {
  componentStatus(run: $runid, component: $component) {
    component {
      id
      name
      image
      version
      cpulimit
      memlimit
      gpurequest
      replicas
      postprocessing
      ports
    }
    state {
      state
      replicas
    }
    instances {
      pod
      status {
        conditions {
          message
          reason
          status
          type
        }
        containerStatuses {
          ...containerStatus
        }
        hostIP
        initContainerStatuses {
          ...containerStatus
        }
        message
        nominatedNodeName
        phase
        podIP
        qosClass
        reason
        startTime
      }
      log
    }
  }
}
    ${ContainerStatusFragmentDoc}`;

/**
 * __useComponentStatusQuery__
 *
 * To run a query within a React component, call `useComponentStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useComponentStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComponentStatusQuery({
 *   variables: {
 *      runid: // value for 'runid'
 *      component: // value for 'component'
 *   },
 * });
 */
export function useComponentStatusQuery(baseOptions: Apollo.QueryHookOptions<ComponentStatusQuery, ComponentStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ComponentStatusQuery, ComponentStatusQueryVariables>(ComponentStatusDocument, options);
      }
export function useComponentStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ComponentStatusQuery, ComponentStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ComponentStatusQuery, ComponentStatusQueryVariables>(ComponentStatusDocument, options);
        }
export type ComponentStatusQueryHookResult = ReturnType<typeof useComponentStatusQuery>;
export type ComponentStatusLazyQueryHookResult = ReturnType<typeof useComponentStatusLazyQuery>;
export type ComponentStatusQueryResult = Apollo.QueryResult<ComponentStatusQuery, ComponentStatusQueryVariables>;
export const SessionDocument = gql`
    query session($sessionid: ID!) {
  session(id: $sessionid) {
    ...sessionProps
  }
}
    ${SessionPropsFragmentDoc}`;

/**
 * __useSessionQuery__
 *
 * To run a query within a React component, call `useSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionQuery({
 *   variables: {
 *      sessionid: // value for 'sessionid'
 *   },
 * });
 */
export function useSessionQuery(baseOptions: Apollo.QueryHookOptions<SessionQuery, SessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SessionQuery, SessionQueryVariables>(SessionDocument, options);
      }
export function useSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SessionQuery, SessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SessionQuery, SessionQueryVariables>(SessionDocument, options);
        }
export type SessionQueryHookResult = ReturnType<typeof useSessionQuery>;
export type SessionLazyQueryHookResult = ReturnType<typeof useSessionLazyQuery>;
export type SessionQueryResult = Apollo.QueryResult<SessionQuery, SessionQueryVariables>;
export const VideoInfoDocument = gql`
    query videoInfo($url: String!) {
  videoInfo(url: $url) {
    url
    width
    height
    codec
    fps
    duration
    bitrate
    error
  }
}
    `;

/**
 * __useVideoInfoQuery__
 *
 * To run a query within a React component, call `useVideoInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideoInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoInfoQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useVideoInfoQuery(baseOptions: Apollo.QueryHookOptions<VideoInfoQuery, VideoInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VideoInfoQuery, VideoInfoQueryVariables>(VideoInfoDocument, options);
      }
export function useVideoInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VideoInfoQuery, VideoInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VideoInfoQuery, VideoInfoQueryVariables>(VideoInfoDocument, options);
        }
export type VideoInfoQueryHookResult = ReturnType<typeof useVideoInfoQuery>;
export type VideoInfoLazyQueryHookResult = ReturnType<typeof useVideoInfoLazyQuery>;
export type VideoInfoQueryResult = Apollo.QueryResult<VideoInfoQuery, VideoInfoQueryVariables>;
export const SnapshotDocument = gql`
    query snapshot($video: ID!) {
  snapshot(id: $video)
}
    `;

/**
 * __useSnapshotQuery__
 *
 * To run a query within a React component, call `useSnapshotQuery` and pass it any options that fit your needs.
 * When your component renders, `useSnapshotQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSnapshotQuery({
 *   variables: {
 *      video: // value for 'video'
 *   },
 * });
 */
export function useSnapshotQuery(baseOptions: Apollo.QueryHookOptions<SnapshotQuery, SnapshotQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SnapshotQuery, SnapshotQueryVariables>(SnapshotDocument, options);
      }
export function useSnapshotLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SnapshotQuery, SnapshotQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SnapshotQuery, SnapshotQueryVariables>(SnapshotDocument, options);
        }
export type SnapshotQueryHookResult = ReturnType<typeof useSnapshotQuery>;
export type SnapshotLazyQueryHookResult = ReturnType<typeof useSnapshotLazyQuery>;
export type SnapshotQueryResult = Apollo.QueryResult<SnapshotQuery, SnapshotQueryVariables>;
export const SessionVideoDocument = gql`
    query sessionVideo($id: ID!) {
  sessionVideo(id: $id) {
    ...sessionVideoProps
  }
}
    ${SessionVideoPropsFragmentDoc}`;

/**
 * __useSessionVideoQuery__
 *
 * To run a query within a React component, call `useSessionVideoQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessionVideoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionVideoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSessionVideoQuery(baseOptions: Apollo.QueryHookOptions<SessionVideoQuery, SessionVideoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SessionVideoQuery, SessionVideoQueryVariables>(SessionVideoDocument, options);
      }
export function useSessionVideoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SessionVideoQuery, SessionVideoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SessionVideoQuery, SessionVideoQueryVariables>(SessionVideoDocument, options);
        }
export type SessionVideoQueryHookResult = ReturnType<typeof useSessionVideoQuery>;
export type SessionVideoLazyQueryHookResult = ReturnType<typeof useSessionVideoLazyQuery>;
export type SessionVideoQueryResult = Apollo.QueryResult<SessionVideoQuery, SessionVideoQueryVariables>;
export const SessionsDocument = gql`
    query sessions($pagination: Pagination, $sorting: [Sorting], $search: String, $creationStart: Long, $creationEnd: Long, $pitches: [ID], $approved: Boolean) {
  sessions(input: {pagination: $pagination, sorting: $sorting, search: $search, creationStart: $creationStart, creationEnd: $creationEnd, pitches: $pitches, approved: $approved}) {
    sessions {
      ...sessionProps
    }
    count
  }
}
    ${SessionPropsFragmentDoc}`;

/**
 * __useSessionsQuery__
 *
 * To run a query within a React component, call `useSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sorting: // value for 'sorting'
 *      search: // value for 'search'
 *      creationStart: // value for 'creationStart'
 *      creationEnd: // value for 'creationEnd'
 *      pitches: // value for 'pitches'
 *      approved: // value for 'approved'
 *   },
 * });
 */
export function useSessionsQuery(baseOptions?: Apollo.QueryHookOptions<SessionsQuery, SessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SessionsQuery, SessionsQueryVariables>(SessionsDocument, options);
      }
export function useSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SessionsQuery, SessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SessionsQuery, SessionsQueryVariables>(SessionsDocument, options);
        }
export type SessionsQueryHookResult = ReturnType<typeof useSessionsQuery>;
export type SessionsLazyQueryHookResult = ReturnType<typeof useSessionsLazyQuery>;
export type SessionsQueryResult = Apollo.QueryResult<SessionsQuery, SessionsQueryVariables>;
export const AllsessionsDocument = gql`
    query allsessions {
  allsessions {
    ...sessionProps
  }
}
    ${SessionPropsFragmentDoc}`;

/**
 * __useAllsessionsQuery__
 *
 * To run a query within a React component, call `useAllsessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllsessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllsessionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllsessionsQuery(baseOptions?: Apollo.QueryHookOptions<AllsessionsQuery, AllsessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllsessionsQuery, AllsessionsQueryVariables>(AllsessionsDocument, options);
      }
export function useAllsessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllsessionsQuery, AllsessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllsessionsQuery, AllsessionsQueryVariables>(AllsessionsDocument, options);
        }
export type AllsessionsQueryHookResult = ReturnType<typeof useAllsessionsQuery>;
export type AllsessionsLazyQueryHookResult = ReturnType<typeof useAllsessionsLazyQuery>;
export type AllsessionsQueryResult = Apollo.QueryResult<AllsessionsQuery, AllsessionsQueryVariables>;
export const SessionResultDocument = gql`
    query sessionResult($sessionid: ID!) {
  sessionResult(id: $sessionid)
}
    `;

/**
 * __useSessionResultQuery__
 *
 * To run a query within a React component, call `useSessionResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessionResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionResultQuery({
 *   variables: {
 *      sessionid: // value for 'sessionid'
 *   },
 * });
 */
export function useSessionResultQuery(baseOptions: Apollo.QueryHookOptions<SessionResultQuery, SessionResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SessionResultQuery, SessionResultQueryVariables>(SessionResultDocument, options);
      }
export function useSessionResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SessionResultQuery, SessionResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SessionResultQuery, SessionResultQueryVariables>(SessionResultDocument, options);
        }
export type SessionResultQueryHookResult = ReturnType<typeof useSessionResultQuery>;
export type SessionResultLazyQueryHookResult = ReturnType<typeof useSessionResultLazyQuery>;
export type SessionResultQueryResult = Apollo.QueryResult<SessionResultQuery, SessionResultQueryVariables>;
export const AddSessionDocument = gql`
    mutation AddSession($input: AddSessionInput) {
  addSession(input: $input) {
    ...sessionProps
  }
}
    ${SessionPropsFragmentDoc}`;

/**
 * __useAddSessionMutation__
 *
 * To run a mutation, you first call `useAddSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSessionMutation, { data, loading, error }] = useAddSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSessionMutation(baseOptions?: Apollo.MutationHookOptions<AddSessionMutation, AddSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSessionMutation, AddSessionMutationVariables>(AddSessionDocument, options);
      }
export type AddSessionMutationHookResult = ReturnType<typeof useAddSessionMutation>;
export type AddSessionMutationResult = Apollo.MutationResult<AddSessionMutation>;
export type AddSessionMutationOptions = Apollo.BaseMutationOptions<AddSessionMutation, AddSessionMutationVariables>;
export const UpdateSessionDocument = gql`
    mutation UpdateSession($id: ID!, $input: AddSessionInput) {
  updateSession(id: $id, input: $input) {
    ...sessionProps
  }
}
    ${SessionPropsFragmentDoc}`;

/**
 * __useUpdateSessionMutation__
 *
 * To run a mutation, you first call `useUpdateSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSessionMutation, { data, loading, error }] = useUpdateSessionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSessionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSessionMutation, UpdateSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSessionMutation, UpdateSessionMutationVariables>(UpdateSessionDocument, options);
      }
export type UpdateSessionMutationHookResult = ReturnType<typeof useUpdateSessionMutation>;
export type UpdateSessionMutationResult = Apollo.MutationResult<UpdateSessionMutation>;
export type UpdateSessionMutationOptions = Apollo.BaseMutationOptions<UpdateSessionMutation, UpdateSessionMutationVariables>;
export const DeleteSessionDocument = gql`
    mutation DeleteSession($id: ID!) {
  deleteSession(id: $id)
}
    `;

/**
 * __useDeleteSessionMutation__
 *
 * To run a mutation, you first call `useDeleteSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSessionMutation, { data, loading, error }] = useDeleteSessionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSessionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSessionMutation, DeleteSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSessionMutation, DeleteSessionMutationVariables>(DeleteSessionDocument, options);
      }
export type DeleteSessionMutationHookResult = ReturnType<typeof useDeleteSessionMutation>;
export type DeleteSessionMutationResult = Apollo.MutationResult<DeleteSessionMutation>;
export type DeleteSessionMutationOptions = Apollo.BaseMutationOptions<DeleteSessionMutation, DeleteSessionMutationVariables>;
export const StartSessionDocument = gql`
    mutation StartSession($id: ID!) {
  startSession(id: $id) {
    ...sessionProps
  }
}
    ${SessionPropsFragmentDoc}`;

/**
 * __useStartSessionMutation__
 *
 * To run a mutation, you first call `useStartSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startSessionMutation, { data, loading, error }] = useStartSessionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStartSessionMutation(baseOptions?: Apollo.MutationHookOptions<StartSessionMutation, StartSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartSessionMutation, StartSessionMutationVariables>(StartSessionDocument, options);
      }
export type StartSessionMutationHookResult = ReturnType<typeof useStartSessionMutation>;
export type StartSessionMutationResult = Apollo.MutationResult<StartSessionMutation>;
export type StartSessionMutationOptions = Apollo.BaseMutationOptions<StartSessionMutation, StartSessionMutationVariables>;
export const UpdateCalibrationDocument = gql`
    mutation updateCalibration($id: ID!, $calibration: String!, $clickpoints: String!) {
  updateCalibration(id: $id, calibration: $calibration, clickPoints: $clickpoints) {
    ...sessionVideoProps
  }
}
    ${SessionVideoPropsFragmentDoc}`;

/**
 * __useUpdateCalibrationMutation__
 *
 * To run a mutation, you first call `useUpdateCalibrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCalibrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCalibrationMutation, { data, loading, error }] = useUpdateCalibrationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      calibration: // value for 'calibration'
 *      clickpoints: // value for 'clickpoints'
 *   },
 * });
 */
export function useUpdateCalibrationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCalibrationMutation, UpdateCalibrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCalibrationMutation, UpdateCalibrationMutationVariables>(UpdateCalibrationDocument, options);
      }
export type UpdateCalibrationMutationHookResult = ReturnType<typeof useUpdateCalibrationMutation>;
export type UpdateCalibrationMutationResult = Apollo.MutationResult<UpdateCalibrationMutation>;
export type UpdateCalibrationMutationOptions = Apollo.BaseMutationOptions<UpdateCalibrationMutation, UpdateCalibrationMutationVariables>;
export const SessionAddEventDocument = gql`
    mutation sessionAddEvent($id: ID, $input: AddSessionEventInput!) {
  sessionAddEvent(id: $id, input: $input) {
    ...sessionProps
  }
}
    ${SessionPropsFragmentDoc}`;

/**
 * __useSessionAddEventMutation__
 *
 * To run a mutation, you first call `useSessionAddEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSessionAddEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sessionAddEventMutation, { data, loading, error }] = useSessionAddEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSessionAddEventMutation(baseOptions?: Apollo.MutationHookOptions<SessionAddEventMutation, SessionAddEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SessionAddEventMutation, SessionAddEventMutationVariables>(SessionAddEventDocument, options);
      }
export type SessionAddEventMutationHookResult = ReturnType<typeof useSessionAddEventMutation>;
export type SessionAddEventMutationResult = Apollo.MutationResult<SessionAddEventMutation>;
export type SessionAddEventMutationOptions = Apollo.BaseMutationOptions<SessionAddEventMutation, SessionAddEventMutationVariables>;
export const SessionUpdateEventDocument = gql`
    mutation sessionUpdateEvent($id: ID, $input: AddSessionEventInput!) {
  sessionUpdateEvent(id: $id, input: $input) {
    ...sessionProps
  }
}
    ${SessionPropsFragmentDoc}`;

/**
 * __useSessionUpdateEventMutation__
 *
 * To run a mutation, you first call `useSessionUpdateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSessionUpdateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sessionUpdateEventMutation, { data, loading, error }] = useSessionUpdateEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSessionUpdateEventMutation(baseOptions?: Apollo.MutationHookOptions<SessionUpdateEventMutation, SessionUpdateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SessionUpdateEventMutation, SessionUpdateEventMutationVariables>(SessionUpdateEventDocument, options);
      }
export type SessionUpdateEventMutationHookResult = ReturnType<typeof useSessionUpdateEventMutation>;
export type SessionUpdateEventMutationResult = Apollo.MutationResult<SessionUpdateEventMutation>;
export type SessionUpdateEventMutationOptions = Apollo.BaseMutationOptions<SessionUpdateEventMutation, SessionUpdateEventMutationVariables>;
export const SessionDeleteEventDocument = gql`
    mutation sessionDeleteEvent($sessionid: ID!, $eventid: ID!) {
  sessionDeleteEvent(id: $sessionid, eventId: $eventid) {
    ...sessionProps
  }
}
    ${SessionPropsFragmentDoc}`;

/**
 * __useSessionDeleteEventMutation__
 *
 * To run a mutation, you first call `useSessionDeleteEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSessionDeleteEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sessionDeleteEventMutation, { data, loading, error }] = useSessionDeleteEventMutation({
 *   variables: {
 *      sessionid: // value for 'sessionid'
 *      eventid: // value for 'eventid'
 *   },
 * });
 */
export function useSessionDeleteEventMutation(baseOptions?: Apollo.MutationHookOptions<SessionDeleteEventMutation, SessionDeleteEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SessionDeleteEventMutation, SessionDeleteEventMutationVariables>(SessionDeleteEventDocument, options);
      }
export type SessionDeleteEventMutationHookResult = ReturnType<typeof useSessionDeleteEventMutation>;
export type SessionDeleteEventMutationResult = Apollo.MutationResult<SessionDeleteEventMutation>;
export type SessionDeleteEventMutationOptions = Apollo.BaseMutationOptions<SessionDeleteEventMutation, SessionDeleteEventMutationVariables>;
export const SessionAddPeriodDocument = gql`
    mutation sessionAddPeriod($id: ID, $input: AddSessionPeriodInput!) {
  sessionAddPeriod(id: $id, input: $input) {
    ...sessionProps
  }
}
    ${SessionPropsFragmentDoc}`;

/**
 * __useSessionAddPeriodMutation__
 *
 * To run a mutation, you first call `useSessionAddPeriodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSessionAddPeriodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sessionAddPeriodMutation, { data, loading, error }] = useSessionAddPeriodMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSessionAddPeriodMutation(baseOptions?: Apollo.MutationHookOptions<SessionAddPeriodMutation, SessionAddPeriodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SessionAddPeriodMutation, SessionAddPeriodMutationVariables>(SessionAddPeriodDocument, options);
      }
export type SessionAddPeriodMutationHookResult = ReturnType<typeof useSessionAddPeriodMutation>;
export type SessionAddPeriodMutationResult = Apollo.MutationResult<SessionAddPeriodMutation>;
export type SessionAddPeriodMutationOptions = Apollo.BaseMutationOptions<SessionAddPeriodMutation, SessionAddPeriodMutationVariables>;
export const SessionUpdatePeriodDocument = gql`
    mutation sessionUpdatePeriod($id: ID, $input: AddSessionPeriodInput!) {
  sessionUpdatePeriod(id: $id, input: $input) {
    ...sessionProps
  }
}
    ${SessionPropsFragmentDoc}`;

/**
 * __useSessionUpdatePeriodMutation__
 *
 * To run a mutation, you first call `useSessionUpdatePeriodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSessionUpdatePeriodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sessionUpdatePeriodMutation, { data, loading, error }] = useSessionUpdatePeriodMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSessionUpdatePeriodMutation(baseOptions?: Apollo.MutationHookOptions<SessionUpdatePeriodMutation, SessionUpdatePeriodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SessionUpdatePeriodMutation, SessionUpdatePeriodMutationVariables>(SessionUpdatePeriodDocument, options);
      }
export type SessionUpdatePeriodMutationHookResult = ReturnType<typeof useSessionUpdatePeriodMutation>;
export type SessionUpdatePeriodMutationResult = Apollo.MutationResult<SessionUpdatePeriodMutation>;
export type SessionUpdatePeriodMutationOptions = Apollo.BaseMutationOptions<SessionUpdatePeriodMutation, SessionUpdatePeriodMutationVariables>;
export const SessionDeletePeriodDocument = gql`
    mutation sessionDeletePeriod($sessionid: ID!, $periodid: ID!) {
  sessionDeletePeriod(id: $sessionid, periodId: $periodid) {
    ...sessionProps
  }
}
    ${SessionPropsFragmentDoc}`;

/**
 * __useSessionDeletePeriodMutation__
 *
 * To run a mutation, you first call `useSessionDeletePeriodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSessionDeletePeriodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sessionDeletePeriodMutation, { data, loading, error }] = useSessionDeletePeriodMutation({
 *   variables: {
 *      sessionid: // value for 'sessionid'
 *      periodid: // value for 'periodid'
 *   },
 * });
 */
export function useSessionDeletePeriodMutation(baseOptions?: Apollo.MutationHookOptions<SessionDeletePeriodMutation, SessionDeletePeriodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SessionDeletePeriodMutation, SessionDeletePeriodMutationVariables>(SessionDeletePeriodDocument, options);
      }
export type SessionDeletePeriodMutationHookResult = ReturnType<typeof useSessionDeletePeriodMutation>;
export type SessionDeletePeriodMutationResult = Apollo.MutationResult<SessionDeletePeriodMutation>;
export type SessionDeletePeriodMutationOptions = Apollo.BaseMutationOptions<SessionDeletePeriodMutation, SessionDeletePeriodMutationVariables>;
export const SessionAddLabelPositionDocument = gql`
    mutation sessionAddLabelPosition($id: ID, $input: AddSessionLabelPositionInput!) {
  sessionAddLabelPosition(id: $id, input: $input) {
    ...sessionProps
  }
}
    ${SessionPropsFragmentDoc}`;

/**
 * __useSessionAddLabelPositionMutation__
 *
 * To run a mutation, you first call `useSessionAddLabelPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSessionAddLabelPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sessionAddLabelPositionMutation, { data, loading, error }] = useSessionAddLabelPositionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSessionAddLabelPositionMutation(baseOptions?: Apollo.MutationHookOptions<SessionAddLabelPositionMutation, SessionAddLabelPositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SessionAddLabelPositionMutation, SessionAddLabelPositionMutationVariables>(SessionAddLabelPositionDocument, options);
      }
export type SessionAddLabelPositionMutationHookResult = ReturnType<typeof useSessionAddLabelPositionMutation>;
export type SessionAddLabelPositionMutationResult = Apollo.MutationResult<SessionAddLabelPositionMutation>;
export type SessionAddLabelPositionMutationOptions = Apollo.BaseMutationOptions<SessionAddLabelPositionMutation, SessionAddLabelPositionMutationVariables>;
export const SessionDeleteLabelPositionsDocument = gql`
    mutation sessionDeleteLabelPositions($sessionid: ID!, $labelPositionIds: [ID!]) {
  sessionDeleteLabelPositions(id: $sessionid, labelPositionIds: $labelPositionIds) {
    ...sessionProps
  }
}
    ${SessionPropsFragmentDoc}`;

/**
 * __useSessionDeleteLabelPositionsMutation__
 *
 * To run a mutation, you first call `useSessionDeleteLabelPositionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSessionDeleteLabelPositionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sessionDeleteLabelPositionsMutation, { data, loading, error }] = useSessionDeleteLabelPositionsMutation({
 *   variables: {
 *      sessionid: // value for 'sessionid'
 *      labelPositionIds: // value for 'labelPositionIds'
 *   },
 * });
 */
export function useSessionDeleteLabelPositionsMutation(baseOptions?: Apollo.MutationHookOptions<SessionDeleteLabelPositionsMutation, SessionDeleteLabelPositionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SessionDeleteLabelPositionsMutation, SessionDeleteLabelPositionsMutationVariables>(SessionDeleteLabelPositionsDocument, options);
      }
export type SessionDeleteLabelPositionsMutationHookResult = ReturnType<typeof useSessionDeleteLabelPositionsMutation>;
export type SessionDeleteLabelPositionsMutationResult = Apollo.MutationResult<SessionDeleteLabelPositionsMutation>;
export type SessionDeleteLabelPositionsMutationOptions = Apollo.BaseMutationOptions<SessionDeleteLabelPositionsMutation, SessionDeleteLabelPositionsMutationVariables>;
export const SessionUpdateTrackLabelTaskDocument = gql`
    mutation sessionUpdateTrackLabelTask($id: ID!, $input: AddTrackLabelTaskInput!) {
  sessionUpdateTrackLabelTask(id: $id, input: $input) {
    ...sessionProps
  }
}
    ${SessionPropsFragmentDoc}`;

/**
 * __useSessionUpdateTrackLabelTaskMutation__
 *
 * To run a mutation, you first call `useSessionUpdateTrackLabelTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSessionUpdateTrackLabelTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sessionUpdateTrackLabelTaskMutation, { data, loading, error }] = useSessionUpdateTrackLabelTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSessionUpdateTrackLabelTaskMutation(baseOptions?: Apollo.MutationHookOptions<SessionUpdateTrackLabelTaskMutation, SessionUpdateTrackLabelTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SessionUpdateTrackLabelTaskMutation, SessionUpdateTrackLabelTaskMutationVariables>(SessionUpdateTrackLabelTaskDocument, options);
      }
export type SessionUpdateTrackLabelTaskMutationHookResult = ReturnType<typeof useSessionUpdateTrackLabelTaskMutation>;
export type SessionUpdateTrackLabelTaskMutationResult = Apollo.MutationResult<SessionUpdateTrackLabelTaskMutation>;
export type SessionUpdateTrackLabelTaskMutationOptions = Apollo.BaseMutationOptions<SessionUpdateTrackLabelTaskMutation, SessionUpdateTrackLabelTaskMutationVariables>;
export const SessionAddTrackLabelTasksDocument = gql`
    mutation sessionAddTrackLabelTasks($id: ID!, $input: [AddTrackLabelTaskInput!]) {
  sessionAddTrackLabelTasks(id: $id, input: $input) {
    ...sessionProps
  }
}
    ${SessionPropsFragmentDoc}`;

/**
 * __useSessionAddTrackLabelTasksMutation__
 *
 * To run a mutation, you first call `useSessionAddTrackLabelTasksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSessionAddTrackLabelTasksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sessionAddTrackLabelTasksMutation, { data, loading, error }] = useSessionAddTrackLabelTasksMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSessionAddTrackLabelTasksMutation(baseOptions?: Apollo.MutationHookOptions<SessionAddTrackLabelTasksMutation, SessionAddTrackLabelTasksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SessionAddTrackLabelTasksMutation, SessionAddTrackLabelTasksMutationVariables>(SessionAddTrackLabelTasksDocument, options);
      }
export type SessionAddTrackLabelTasksMutationHookResult = ReturnType<typeof useSessionAddTrackLabelTasksMutation>;
export type SessionAddTrackLabelTasksMutationResult = Apollo.MutationResult<SessionAddTrackLabelTasksMutation>;
export type SessionAddTrackLabelTasksMutationOptions = Apollo.BaseMutationOptions<SessionAddTrackLabelTasksMutation, SessionAddTrackLabelTasksMutationVariables>;
export const SessionDeleteTrackLabelTaskDocument = gql`
    mutation sessionDeleteTrackLabelTask($sessionid: ID!, $taskId: ID!) {
  sessionDeleteTrackLabelTask(id: $sessionid, taskId: $taskId) {
    ...sessionProps
  }
}
    ${SessionPropsFragmentDoc}`;

/**
 * __useSessionDeleteTrackLabelTaskMutation__
 *
 * To run a mutation, you first call `useSessionDeleteTrackLabelTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSessionDeleteTrackLabelTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sessionDeleteTrackLabelTaskMutation, { data, loading, error }] = useSessionDeleteTrackLabelTaskMutation({
 *   variables: {
 *      sessionid: // value for 'sessionid'
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useSessionDeleteTrackLabelTaskMutation(baseOptions?: Apollo.MutationHookOptions<SessionDeleteTrackLabelTaskMutation, SessionDeleteTrackLabelTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SessionDeleteTrackLabelTaskMutation, SessionDeleteTrackLabelTaskMutationVariables>(SessionDeleteTrackLabelTaskDocument, options);
      }
export type SessionDeleteTrackLabelTaskMutationHookResult = ReturnType<typeof useSessionDeleteTrackLabelTaskMutation>;
export type SessionDeleteTrackLabelTaskMutationResult = Apollo.MutationResult<SessionDeleteTrackLabelTaskMutation>;
export type SessionDeleteTrackLabelTaskMutationOptions = Apollo.BaseMutationOptions<SessionDeleteTrackLabelTaskMutation, SessionDeleteTrackLabelTaskMutationVariables>;
export const SessionClearTrackLabelTasksDocument = gql`
    mutation sessionClearTrackLabelTasks($sessionid: ID!) {
  sessionClearTrackLabelTasks(id: $sessionid) {
    ...sessionProps
  }
}
    ${SessionPropsFragmentDoc}`;

/**
 * __useSessionClearTrackLabelTasksMutation__
 *
 * To run a mutation, you first call `useSessionClearTrackLabelTasksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSessionClearTrackLabelTasksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sessionClearTrackLabelTasksMutation, { data, loading, error }] = useSessionClearTrackLabelTasksMutation({
 *   variables: {
 *      sessionid: // value for 'sessionid'
 *   },
 * });
 */
export function useSessionClearTrackLabelTasksMutation(baseOptions?: Apollo.MutationHookOptions<SessionClearTrackLabelTasksMutation, SessionClearTrackLabelTasksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SessionClearTrackLabelTasksMutation, SessionClearTrackLabelTasksMutationVariables>(SessionClearTrackLabelTasksDocument, options);
      }
export type SessionClearTrackLabelTasksMutationHookResult = ReturnType<typeof useSessionClearTrackLabelTasksMutation>;
export type SessionClearTrackLabelTasksMutationResult = Apollo.MutationResult<SessionClearTrackLabelTasksMutation>;
export type SessionClearTrackLabelTasksMutationOptions = Apollo.BaseMutationOptions<SessionClearTrackLabelTasksMutation, SessionClearTrackLabelTasksMutationVariables>;
export const SessionUpdateVideoDocument = gql`
    mutation sessionUpdateVideo($id: ID, $input: AddSessionVideoInput!) {
  sessionUpdateVideo(id: $id, input: $input) {
    ...sessionProps
  }
}
    ${SessionPropsFragmentDoc}`;

/**
 * __useSessionUpdateVideoMutation__
 *
 * To run a mutation, you first call `useSessionUpdateVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSessionUpdateVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sessionUpdateVideoMutation, { data, loading, error }] = useSessionUpdateVideoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSessionUpdateVideoMutation(baseOptions?: Apollo.MutationHookOptions<SessionUpdateVideoMutation, SessionUpdateVideoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SessionUpdateVideoMutation, SessionUpdateVideoMutationVariables>(SessionUpdateVideoDocument, options);
      }
export type SessionUpdateVideoMutationHookResult = ReturnType<typeof useSessionUpdateVideoMutation>;
export type SessionUpdateVideoMutationResult = Apollo.MutationResult<SessionUpdateVideoMutation>;
export type SessionUpdateVideoMutationOptions = Apollo.BaseMutationOptions<SessionUpdateVideoMutation, SessionUpdateVideoMutationVariables>;
export const SessionAddVideoDocument = gql`
    mutation sessionAddVideo($id: ID, $input: AddSessionVideoInput!) {
  sessionAddVideo(id: $id, input: $input) {
    ...sessionProps
  }
}
    ${SessionPropsFragmentDoc}`;

/**
 * __useSessionAddVideoMutation__
 *
 * To run a mutation, you first call `useSessionAddVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSessionAddVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sessionAddVideoMutation, { data, loading, error }] = useSessionAddVideoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSessionAddVideoMutation(baseOptions?: Apollo.MutationHookOptions<SessionAddVideoMutation, SessionAddVideoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SessionAddVideoMutation, SessionAddVideoMutationVariables>(SessionAddVideoDocument, options);
      }
export type SessionAddVideoMutationHookResult = ReturnType<typeof useSessionAddVideoMutation>;
export type SessionAddVideoMutationResult = Apollo.MutationResult<SessionAddVideoMutation>;
export type SessionAddVideoMutationOptions = Apollo.BaseMutationOptions<SessionAddVideoMutation, SessionAddVideoMutationVariables>;
export const SessionDeleteVideoDocument = gql`
    mutation sessionDeleteVideo($sessionid: ID!, $videoId: ID!) {
  sessionDeleteVideo(id: $sessionid, videoId: $videoId) {
    ...sessionProps
  }
}
    ${SessionPropsFragmentDoc}`;

/**
 * __useSessionDeleteVideoMutation__
 *
 * To run a mutation, you first call `useSessionDeleteVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSessionDeleteVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sessionDeleteVideoMutation, { data, loading, error }] = useSessionDeleteVideoMutation({
 *   variables: {
 *      sessionid: // value for 'sessionid'
 *      videoId: // value for 'videoId'
 *   },
 * });
 */
export function useSessionDeleteVideoMutation(baseOptions?: Apollo.MutationHookOptions<SessionDeleteVideoMutation, SessionDeleteVideoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SessionDeleteVideoMutation, SessionDeleteVideoMutationVariables>(SessionDeleteVideoDocument, options);
      }
export type SessionDeleteVideoMutationHookResult = ReturnType<typeof useSessionDeleteVideoMutation>;
export type SessionDeleteVideoMutationResult = Apollo.MutationResult<SessionDeleteVideoMutation>;
export type SessionDeleteVideoMutationOptions = Apollo.BaseMutationOptions<SessionDeleteVideoMutation, SessionDeleteVideoMutationVariables>;
export const UpdateVideoOrderDocument = gql`
    mutation updateVideoOrder($sessionid: ID!, $order: [VideoOrderInput!]!) {
  updateVideoOrder(id: $sessionid, order: $order) {
    ...sessionProps
  }
}
    ${SessionPropsFragmentDoc}`;

/**
 * __useUpdateVideoOrderMutation__
 *
 * To run a mutation, you first call `useUpdateVideoOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVideoOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVideoOrderMutation, { data, loading, error }] = useUpdateVideoOrderMutation({
 *   variables: {
 *      sessionid: // value for 'sessionid'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUpdateVideoOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVideoOrderMutation, UpdateVideoOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVideoOrderMutation, UpdateVideoOrderMutationVariables>(UpdateVideoOrderDocument, options);
      }
export type UpdateVideoOrderMutationHookResult = ReturnType<typeof useUpdateVideoOrderMutation>;
export type UpdateVideoOrderMutationResult = Apollo.MutationResult<UpdateVideoOrderMutation>;
export type UpdateVideoOrderMutationOptions = Apollo.BaseMutationOptions<UpdateVideoOrderMutation, UpdateVideoOrderMutationVariables>;
export const UpdateCalibrationImageDocument = gql`
    mutation updateCalibrationImage($id: ID!, $calibrationImage: String!) {
  updateCalibrationImage(id: $id, calibrationImage: $calibrationImage)
}
    `;

/**
 * __useUpdateCalibrationImageMutation__
 *
 * To run a mutation, you first call `useUpdateCalibrationImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCalibrationImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCalibrationImageMutation, { data, loading, error }] = useUpdateCalibrationImageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      calibrationImage: // value for 'calibrationImage'
 *   },
 * });
 */
export function useUpdateCalibrationImageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCalibrationImageMutation, UpdateCalibrationImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCalibrationImageMutation, UpdateCalibrationImageMutationVariables>(UpdateCalibrationImageDocument, options);
      }
export type UpdateCalibrationImageMutationHookResult = ReturnType<typeof useUpdateCalibrationImageMutation>;
export type UpdateCalibrationImageMutationResult = Apollo.MutationResult<UpdateCalibrationImageMutation>;
export type UpdateCalibrationImageMutationOptions = Apollo.BaseMutationOptions<UpdateCalibrationImageMutation, UpdateCalibrationImageMutationVariables>;
export const MatchingVideoDocument = gql`
    query matchingVideo($id: ID!) {
  matchingVideo(id: $id) {
    ...sessionVideoProps
  }
}
    ${SessionVideoPropsFragmentDoc}`;

/**
 * __useMatchingVideoQuery__
 *
 * To run a query within a React component, call `useMatchingVideoQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchingVideoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchingVideoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMatchingVideoQuery(baseOptions: Apollo.QueryHookOptions<MatchingVideoQuery, MatchingVideoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchingVideoQuery, MatchingVideoQueryVariables>(MatchingVideoDocument, options);
      }
export function useMatchingVideoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchingVideoQuery, MatchingVideoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchingVideoQuery, MatchingVideoQueryVariables>(MatchingVideoDocument, options);
        }
export type MatchingVideoQueryHookResult = ReturnType<typeof useMatchingVideoQuery>;
export type MatchingVideoLazyQueryHookResult = ReturnType<typeof useMatchingVideoLazyQuery>;
export type MatchingVideoQueryResult = Apollo.QueryResult<MatchingVideoQuery, MatchingVideoQueryVariables>;
export const ImportOptaF7Document = gql`
    mutation importOptaF7($id: ID, $xml: String!) {
  importOptaF7(id: $id, xml: $xml) {
    ...sessionProps
  }
}
    ${SessionPropsFragmentDoc}`;

/**
 * __useImportOptaF7Mutation__
 *
 * To run a mutation, you first call `useImportOptaF7Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportOptaF7Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importOptaF7Mutation, { data, loading, error }] = useImportOptaF7Mutation({
 *   variables: {
 *      id: // value for 'id'
 *      xml: // value for 'xml'
 *   },
 * });
 */
export function useImportOptaF7Mutation(baseOptions?: Apollo.MutationHookOptions<ImportOptaF7Mutation, ImportOptaF7MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportOptaF7Mutation, ImportOptaF7MutationVariables>(ImportOptaF7Document, options);
      }
export type ImportOptaF7MutationHookResult = ReturnType<typeof useImportOptaF7Mutation>;
export type ImportOptaF7MutationResult = Apollo.MutationResult<ImportOptaF7Mutation>;
export type ImportOptaF7MutationOptions = Apollo.BaseMutationOptions<ImportOptaF7Mutation, ImportOptaF7MutationVariables>;
export const AddUpdateLineupDocument = gql`
    mutation addUpdateLineup($id: ID!, $lineup: [AddLineupEntryInput!]) {
  sessionAddUpdateLineup(id: $id, input: $lineup) {
    ...sessionProps
  }
}
    ${SessionPropsFragmentDoc}`;

/**
 * __useAddUpdateLineupMutation__
 *
 * To run a mutation, you first call `useAddUpdateLineupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUpdateLineupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUpdateLineupMutation, { data, loading, error }] = useAddUpdateLineupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      lineup: // value for 'lineup'
 *   },
 * });
 */
export function useAddUpdateLineupMutation(baseOptions?: Apollo.MutationHookOptions<AddUpdateLineupMutation, AddUpdateLineupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUpdateLineupMutation, AddUpdateLineupMutationVariables>(AddUpdateLineupDocument, options);
      }
export type AddUpdateLineupMutationHookResult = ReturnType<typeof useAddUpdateLineupMutation>;
export type AddUpdateLineupMutationResult = Apollo.MutationResult<AddUpdateLineupMutation>;
export type AddUpdateLineupMutationOptions = Apollo.BaseMutationOptions<AddUpdateLineupMutation, AddUpdateLineupMutationVariables>;
export const ExportEptsDocument = gql`
    mutation exportEpts($id: ID!, $autonomous: Boolean!) {
  exportEpts(id: $id, autonomous: $autonomous) {
    ...sessionProps
  }
}
    ${SessionPropsFragmentDoc}`;

/**
 * __useExportEptsMutation__
 *
 * To run a mutation, you first call `useExportEptsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportEptsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportEptsMutation, { data, loading, error }] = useExportEptsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      autonomous: // value for 'autonomous'
 *   },
 * });
 */
export function useExportEptsMutation(baseOptions?: Apollo.MutationHookOptions<ExportEptsMutation, ExportEptsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportEptsMutation, ExportEptsMutationVariables>(ExportEptsDocument, options);
      }
export type ExportEptsMutationHookResult = ReturnType<typeof useExportEptsMutation>;
export type ExportEptsMutationResult = Apollo.MutationResult<ExportEptsMutation>;
export type ExportEptsMutationOptions = Apollo.BaseMutationOptions<ExportEptsMutation, ExportEptsMutationVariables>;
export const LabelTaskDocument = gql`
    query labelTask($id: ID!) {
  labelTask(id: $id) {
    ...labelTaskProps
  }
}
    ${LabelTaskPropsFragmentDoc}`;

/**
 * __useLabelTaskQuery__
 *
 * To run a query within a React component, call `useLabelTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useLabelTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLabelTaskQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLabelTaskQuery(baseOptions: Apollo.QueryHookOptions<LabelTaskQuery, LabelTaskQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LabelTaskQuery, LabelTaskQueryVariables>(LabelTaskDocument, options);
      }
export function useLabelTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LabelTaskQuery, LabelTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LabelTaskQuery, LabelTaskQueryVariables>(LabelTaskDocument, options);
        }
export type LabelTaskQueryHookResult = ReturnType<typeof useLabelTaskQuery>;
export type LabelTaskLazyQueryHookResult = ReturnType<typeof useLabelTaskLazyQuery>;
export type LabelTaskQueryResult = Apollo.QueryResult<LabelTaskQuery, LabelTaskQueryVariables>;
export const UpdateSettingsDocument = gql`
    mutation updateSettings($settings: UpdateSettingsInput!) {
  updateSettings(input: $settings) {
    ...settingsFragment
  }
}
    ${SettingsFragmentFragmentDoc}`;

/**
 * __useUpdateSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSettingsMutation, { data, loading, error }] = useUpdateSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useUpdateSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSettingsMutation, UpdateSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSettingsMutation, UpdateSettingsMutationVariables>(UpdateSettingsDocument, options);
      }
export type UpdateSettingsMutationHookResult = ReturnType<typeof useUpdateSettingsMutation>;
export type UpdateSettingsMutationResult = Apollo.MutationResult<UpdateSettingsMutation>;
export type UpdateSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateSettingsMutation, UpdateSettingsMutationVariables>;
export const SettingsDocument = gql`
    query settings {
  settings {
    ...settingsFragment
  }
}
    ${SettingsFragmentFragmentDoc}`;

/**
 * __useSettingsQuery__
 *
 * To run a query within a React component, call `useSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSettingsQuery(baseOptions?: Apollo.QueryHookOptions<SettingsQuery, SettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SettingsQuery, SettingsQueryVariables>(SettingsDocument, options);
      }
export function useSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SettingsQuery, SettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SettingsQuery, SettingsQueryVariables>(SettingsDocument, options);
        }
export type SettingsQueryHookResult = ReturnType<typeof useSettingsQuery>;
export type SettingsLazyQueryHookResult = ReturnType<typeof useSettingsLazyQuery>;
export type SettingsQueryResult = Apollo.QueryResult<SettingsQuery, SettingsQueryVariables>;
export const TeamsDocument = gql`
    query teams {
  teams {
    ...teamInfo
  }
}
    ${TeamInfoFragmentDoc}`;

/**
 * __useTeamsQuery__
 *
 * To run a query within a React component, call `useTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTeamsQuery(baseOptions?: Apollo.QueryHookOptions<TeamsQuery, TeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamsQuery, TeamsQueryVariables>(TeamsDocument, options);
      }
export function useTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamsQuery, TeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamsQuery, TeamsQueryVariables>(TeamsDocument, options);
        }
export type TeamsQueryHookResult = ReturnType<typeof useTeamsQuery>;
export type TeamsLazyQueryHookResult = ReturnType<typeof useTeamsLazyQuery>;
export type TeamsQueryResult = Apollo.QueryResult<TeamsQuery, TeamsQueryVariables>;
export const AddTeamDocument = gql`
    mutation addTeam($input: AddTeamInput!) {
  addTeam(input: $input) {
    ...teamInfo
  }
}
    ${TeamInfoFragmentDoc}`;

/**
 * __useAddTeamMutation__
 *
 * To run a mutation, you first call `useAddTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTeamMutation, { data, loading, error }] = useAddTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTeamMutation(baseOptions?: Apollo.MutationHookOptions<AddTeamMutation, AddTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTeamMutation, AddTeamMutationVariables>(AddTeamDocument, options);
      }
export type AddTeamMutationHookResult = ReturnType<typeof useAddTeamMutation>;
export type AddTeamMutationResult = Apollo.MutationResult<AddTeamMutation>;
export type AddTeamMutationOptions = Apollo.BaseMutationOptions<AddTeamMutation, AddTeamMutationVariables>;
export const LoginDocument = gql`
    mutation login($email: String!, $password: String!) {
  login(input: {email: $email, password: $password}) {
    user {
      ...userFragment
    }
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const LoginTokenDocument = gql`
    mutation loginToken($token: String!) {
  loginToken(input: {token: $token}) {
    user {
      ...userFragment
    }
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useLoginTokenMutation__
 *
 * To run a mutation, you first call `useLoginTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginTokenMutation, { data, loading, error }] = useLoginTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useLoginTokenMutation(baseOptions?: Apollo.MutationHookOptions<LoginTokenMutation, LoginTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginTokenMutation, LoginTokenMutationVariables>(LoginTokenDocument, options);
      }
export type LoginTokenMutationHookResult = ReturnType<typeof useLoginTokenMutation>;
export type LoginTokenMutationResult = Apollo.MutationResult<LoginTokenMutation>;
export type LoginTokenMutationOptions = Apollo.BaseMutationOptions<LoginTokenMutation, LoginTokenMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($newpassword: String!) {
  resetPassword(input: {password: $newpassword}) {
    user {
      ...userFragment
    }
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      newpassword: // value for 'newpassword'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const ConfirmRegistrationDocument = gql`
    mutation confirmRegistration($password: String!) {
  confirmRegistration(input: {password: $password}) {
    user {
      ...userFragment
    }
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useConfirmRegistrationMutation__
 *
 * To run a mutation, you first call `useConfirmRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmRegistrationMutation, { data, loading, error }] = useConfirmRegistrationMutation({
 *   variables: {
 *      password: // value for 'password'
 *   },
 * });
 */
export function useConfirmRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmRegistrationMutation, ConfirmRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmRegistrationMutation, ConfirmRegistrationMutationVariables>(ConfirmRegistrationDocument, options);
      }
export type ConfirmRegistrationMutationHookResult = ReturnType<typeof useConfirmRegistrationMutation>;
export type ConfirmRegistrationMutationResult = Apollo.MutationResult<ConfirmRegistrationMutation>;
export type ConfirmRegistrationMutationOptions = Apollo.BaseMutationOptions<ConfirmRegistrationMutation, ConfirmRegistrationMutationVariables>;
export const CreateUserDocument = gql`
    mutation createUser($email: String!, $firstname: String!, $lastname: String!, $account: String!, $roles: [String!]) {
  createUser(input: {email: $email, firstname: $firstname, lastname: $lastname, account: $account, roles: $roles}) {
    user {
      ...userFragment
    }
    error
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      firstname: // value for 'firstname'
 *      lastname: // value for 'lastname'
 *      account: // value for 'account'
 *      roles: // value for 'roles'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($id: ID!, $email: String!, $firstname: String!, $lastname: String!, $roles: [String!]) {
  updateUser(input: {id: $id, email: $email, firstname: $firstname, lastname: $lastname, roles: $roles}) {
    user {
      ...userFragment
    }
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      email: // value for 'email'
 *      firstname: // value for 'firstname'
 *      lastname: // value for 'lastname'
 *      roles: // value for 'roles'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const DeleteUserDocument = gql`
    mutation deleteUser($id: ID!) {
  deleteUser(input: {id: $id}) {
    result
  }
}
    `;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const ResendInviteDocument = gql`
    mutation resendInvite($id: ID!) {
  resendInvite(id: $id)
}
    `;

/**
 * __useResendInviteMutation__
 *
 * To run a mutation, you first call `useResendInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendInviteMutation, { data, loading, error }] = useResendInviteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResendInviteMutation(baseOptions?: Apollo.MutationHookOptions<ResendInviteMutation, ResendInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendInviteMutation, ResendInviteMutationVariables>(ResendInviteDocument, options);
      }
export type ResendInviteMutationHookResult = ReturnType<typeof useResendInviteMutation>;
export type ResendInviteMutationResult = Apollo.MutationResult<ResendInviteMutation>;
export type ResendInviteMutationOptions = Apollo.BaseMutationOptions<ResendInviteMutation, ResendInviteMutationVariables>;
export const MeDocument = gql`
    query me {
  me {
    ...userFragment
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const UserDocument = gql`
    query user($id: ID!) {
  user(id: $id) {
    ...userFragment
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserQuery(baseOptions: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const RolesDocument = gql`
    query roles {
  roles {
    roles {
      name
      privileges
    }
  }
}
    `;

/**
 * __useRolesQuery__
 *
 * To run a query within a React component, call `useRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useRolesQuery(baseOptions?: Apollo.QueryHookOptions<RolesQuery, RolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RolesQuery, RolesQueryVariables>(RolesDocument, options);
      }
export function useRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RolesQuery, RolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RolesQuery, RolesQueryVariables>(RolesDocument, options);
        }
export type RolesQueryHookResult = ReturnType<typeof useRolesQuery>;
export type RolesLazyQueryHookResult = ReturnType<typeof useRolesLazyQuery>;
export type RolesQueryResult = Apollo.QueryResult<RolesQuery, RolesQueryVariables>;
export const AllUsersDocument = gql`
    query allUsers($pagination: Pagination, $sorting: [Sorting], $search: String, $account: String) {
  allUsers(search: $search, sorting: $sorting, pagination: $pagination, account: $account) {
    users {
      ...userFragment
    }
    count
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useAllUsersQuery__
 *
 * To run a query within a React component, call `useAllUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUsersQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sorting: // value for 'sorting'
 *      search: // value for 'search'
 *      account: // value for 'account'
 *   },
 * });
 */
export function useAllUsersQuery(baseOptions?: Apollo.QueryHookOptions<AllUsersQuery, AllUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllUsersQuery, AllUsersQueryVariables>(AllUsersDocument, options);
      }
export function useAllUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllUsersQuery, AllUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllUsersQuery, AllUsersQueryVariables>(AllUsersDocument, options);
        }
export type AllUsersQueryHookResult = ReturnType<typeof useAllUsersQuery>;
export type AllUsersLazyQueryHookResult = ReturnType<typeof useAllUsersLazyQuery>;
export type AllUsersQueryResult = Apollo.QueryResult<AllUsersQuery, AllUsersQueryVariables>;
export const UsersDocument = gql`
    query users {
  users {
    ...userFragment
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useUsersQuery(baseOptions?: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
